export default {
  bank_product: {
    complete_msg:
      'Le agradecemos sinceramente por <span>suscribirse al producto</span> y le reembolsaremos con un producto mejor.',
  },
  enter_amount: 'Ingrese la cantidad.',
  reg_complete: 'Registro completado',
  subscription_details: 'Detalles de la suscripción',
  select_withdrawal_account: 'Seleccionar cuenta de retiro',
  email_address: 'Dirección de correo electrónico',
  product_info: 'Información del Producto',
  new_amount: 'Nueva cantidad',
  min_running_amount: 'Monto mínimo de ejecución ',
  max_running_amount: 'Monto máximo de ejecución ',
  product_type: 'Tipo de producto',
  bank_product_name: 'nombre del producto',
  reg_start_date: 'Fecha de inicio de registro',
  reg_end_date: 'Fecha de finalización de la suscripción ',
  exec_start_date: 'Fecha de inicio de ejecución ',
  exec_end_date: 'Fecha de finalización de la ejecución ',
  basic_info: 'Información básica',
  not_applicable: 'No aplica',
  subscription: 'afiliación',
  service_prepare: 'Se está preparando el servicio.',
  no_buy_list: 'No hay historial de compras.',
  no_sell_list: 'No hay historial de ventas.',
  no_list: 'No hay lista.',
  locale_name: 'Español',
  Sale_registration: 'Registro de venda',
  apply: 'solicitud',
  status: 'estado',
  wallet: 'billetera',
  wallet_address: 'Dirección de billetera',
  wallet_transfer: 'Transferencia de billetera',
  buy: 'Comprar',
  sell: 'venta',
  all: 'Todas',
  breakdown: 'Historia',
  act_buy: 'Comprar',
  act_sell: 'Comprar',
  asset: 'bienes',
  select: 'selección',
  no_select: 'no seleccionado',
  account: 'cuentas',
  balance: 'saldos',
  login: 'login',
  logout: 'finalizar la sesión',
  register: 'Únete como miembro',
  select_cancel: 'Deseleccionar',
  cancel: 'cancelado',
  modify: 'cristal',
  auto_input: '(Introduce automáticamente)',
  confirm: 'confirmación',
  look_up: 'referencia',
  password: 'contraseña',
  account_delete: 'secesión',
  detail: 'más',
  list_detail: 'más detalles',
  birth: 'cumpleaños',
  welcome: 'Bienvenido.',
  please_login: 'Por favor inicio de sesión.',
  id: 'Nombre de usuario',
  find_id: 'Buscar ID',
  find_password: 'He olvidado la contraseña',
  back: 'regreso',
  agreement: 'Los términos del acuerdo',
  info_input: 'La información de entrada',
  success: 'completo',
  agree_msg: 'Estoy de acuerdo.',
  all_agree: 'Estoy de acuerdo en todo',
  agree: 'De acuerdo',
  agreed: 'Acordado',
  confirm_password: 'Confirmar contraseña',
  repeat_password: 'Confirmar contraseña',
  next: 'próximo',
  before: 'Regresa',
  register_success: 'Regístrate ahora mismo.',
  verify: 'confirmación',
  retention: 'retención',
  allow: '(Aceptado)',
  disallow: '(Inaceptable)',
  upload_btn: 'Por favor soltar archivos, o haga clic aquí.',
  continue_entry:
    'Por favor, introduzca su: "[+:verification]" Para seguir adelante.',
  login_msg_1: 'cuentas intento en ONETETHER las monedas relacionados - !',
  login_msg_2:
    'A través de nuestra ONETETHER por favor utilice el trato y carteras y servicios.',
  login_msg_3: 'ONETETHER puede soportar todos los ambientes.',
  cocofx_register: 'ONETETHER Registro',
  register_msg_1:
    'Unirse como miembros. <br /> Por favor, de acuerdo con nuestros términos y condiciones',
  register_msg_3:
    'Una cuenta ONETETHER dará acceso a todos los servicios en la facilidad.',
  register_msg_all:
    'El consentimiento para todo incluye el consentimiento para los artículos obligatorios y opcionales, y puede seleccionar el consentimiento individualmente. Incluso si se niega a aceptar las opciones, el servicio está disponible.',
  register_title: 'Estoy por encima de la edad de 19 años o más.',
  register_title_2: 'Condiciones ONETETHER',
  register_title_3: 'ONETETHER Integración Condiciones del servicio',
  register_title_4: 'ONETETHER apalancamiento de marketing de acuerdo',
  register_title_5:
    'La recopilación y uso de información personal de consentimiento',
  register_title_6:
    'La recopilación y uso de información de localización acuerdo',
  register_title_7:
    'Estoy de acuerdo información de perfil adicional a cobro revertido',
  register_title_8: 'Entrada ONETETHER información de la cuenta',
  register_title_9: 'Información de entrada',
  register_msg_4:
    'Estos términos se aplican a todos los servicios prestados por la empresa. <br /> Al aceptar estos términos, puede utilizar estos servicios sin firmar un contrato separado.',
  required: '[Necesario]',
  option: '[Selectivo]',
  otp_notice: 'El estado se activa y desactiva OTP imposible.',
  required_check: 'Por favor verifique todos los campos requeridos',
  check_input: 'Por favor, introduzca todos los datos.',
  register_guide: 'Cómo utilizar ONETETHER',
  register_step1: 'Haga clic en el botón PAY COCO',
  register_step2: 'Inicia sesión para ONETETHER pago',
  register_step3: 'Pago / recarga ONETETHER Entrar',
  copy: 'Copiado',
  no_account: 'No hay cuentas registradas.',
  inviter_link: 'vínculos de referencia',
  register_used_account: 'Register cuentas utilizadas con frecuencia',
  security_certification: 'Certificación de seguridad',
  admin_security: 'El nivel de seguridad de {action} es {limit}.',
  company: 'empresa',
  exact_calculation: 'ajuste',
  profile: 'Información del miembro',
  inquiry: 'investigación',
  announcement: 'Notificaciones',
  information: 'información',
  history: 'historia',
  pay: 'pago',
  detail_search: 'Búsqueda de texto completo',
  more_view: 'Ver más',
  exchange_store: 'intercambio',
  external_exchange_store: 'Intercambio externo',
  internal_exchange_store: 'Intercambio interno',
  external_transaction: 'Transacción externa',
  internal_transaction: 'Transacción interna',
  favorites: 'Favoritos',
  no_favorite_list: 'No hay favoritos.',
  no_alias: 'Sin alias',
  please_enter_account_name: 'Ingrese el nombre de su cuenta.',
  variable_amount: 'Cantidad variable',
  changes: 'Cambios',
  account_transaction_history_inquiry:
    'Consulta del historial de transacciones de la cuenta',
  exchange_application_completed: 'La solicitud de canje se ha completado.',
  choose_how_pay_fee: 'Elija cómo pagar la tarifa',
  free: 'gratis',
  closing: 'clausura',
  relative_asset_inquiry: 'Consulta de activos relativos',
  please_enter_relative_account_number:
    'Ingrese el número de cuenta correspondiente.',
  Please_enter_relative_wallet_address:
    'Ingrese la dirección de billetera correspondiente.',
  memo: 'memorándum',
  write_history_memo:
    'Es conveniente administrarlo si escribe una nota de historial.',
  re_enter: 'Volver a entrar en',
  transfer_wallet_account: 'Transferir dirección de billetera',
  transfer_wallet_inquiry: 'Transferir consulta de billetera',
  Kiosk: 'Quiosco',
  withdrawable_amount: 'Monto a retirar',
  transferred_assets: 'Transferir activos',
  recipient: 'Recipiente',
  recipient_wallet: 'Billetera destinataria',
  register_user_name_tit:
    'Le recomendamos que complete el nombre real para la certificación de seguridad.',
  register_password_tit:
    'Por favor, complete la dirección de correo electrónico de uso frecuente correctamente.',
  product_name: 'Nombre del producto',
  dividend_type: 'tipo de dividendo',
  auto: 'Automático',
  manual: 'manual',
  s_usdt_protocol: 'Elija un protocolo de Tethers',

  ccf: {
    what_ccf: '¿Qué es CCF?',
    key_coin:
      'Moneda clave de ONETETHER que conecta la criptomoneda con la moneda real',
    ccf_description:
      'Es una moneda clave de CocoBank que convierte varias criptomonedas a través de intercambio directo y transacciones C2C, y 1CCF tiene un valor de USD 1CENT. CCF permite realizar compras y transacciones más rápidas y seguras en ONETETHER.',
    how_use_ccf: '¿Cómo usar CCF?',
    cocobank_wallet_transfer:
      'Transfiera activos de criptomonedas almacenados en intercambios externos a la billetera de ONETETHER.',
    ccf_conversion:
      'Convierta la criptomoneda transferida a la billetera a CCF mediante cambio de moneda directo o transacción C2C.',
    direct_exchange_c2c_deal: 'Transacción C2C de cambio de moneda directo',
    ccf_moved: 'El CCF convertido se transferirá a su cuenta de ONETETHER.',
    how_use_account_ccf: '¡El CCF transferido a su cuenta se usa así!',
    freely_purchase_open_market:
      '¡Compre libremente productos de mercado abierto con CCF!',
    free_deposit_withdrawal:
      '¡Depósito y retiro y transferencia gratis entre cuentas dentro del banco!',
    exchange_currencies_convenient:
      '¡El intercambio entre monedas se vuelve conveniente a través del cambio de moneda directo y transacciones C2C!',
    offline_convenient:
      '¡Utilice los servicios de ONETETHER de manera más conveniente incluso sin conexión!',
    how_wallets_accounts_different:
      '¿En qué se diferencian las billeteras y las cuentas?',
    same_means_storing_cryptocurrency:
      'En CocoBank, las carteras y las cuentas son el mismo medio para almacenar criptomonedas, pero su uso difiere según el tipo de transacción (interna y externa) de la criptomoneda. En otras palabras, la billetera se usa en transacciones (externas) entre el intercambio y ONETETHER, y la cuenta se usa en transacciones (internas) en ONETETHER.',
  },
  header: {
    certification_management: 'Certificación / Gestión',
    c2c_enroll: 'Compra / Venta',
    wallet_list: 'Monedero / Historia y',
    wallet: 'billetera',
    c2c_list: 'historial de compras / ventas',
    no_c2c_sell_list: 'No hay un historial de ventas.',
    transfer_list: 'Cambio History',
    no_transfer_list: 'No hay una historia de cambio.',
    withdrawal_list: 'Entrada / Historia Retiro',
    my_info: 'mi información',
    home: 'Maine',
    payment_history: 'Historial de facturación',
    account_transfer: 'Transferencia de cuenta',
    transfer_history: 'historial de transferencias',
    register_used_account: 'Register cuentas utilizadas con frecuencia',
    exchange: 'para el intercambio',
    exchange_list: 'Cambio History',
    email: 'E-mail',
    email_list: 'Historia de correo electrónico',
    otp: 'OTP',
    otp_list: 'Historia OTP',
    register_account: 'cuenta de registro',
    calculation_account_list: 'Solución de lista de cuentas',
    security_certification: 'Certificación de seguridad',
    exact_calculation: 'ajuste',
    history: 'historia',
    coco_open_market: 'ONETETHER Mercado Abierto',
    information: 'información',
    my_profile: 'mi información',
    email_modify: 'Editar correo electrónico',
    password_modify: 'Editar su contraseña',
    inquiry: 'investigación',
    inquiry_history: 'Detalles de contacto',
    one_on_one_inquiry: '1:1 investigación',
    frequently_asked_questions: 'Preguntas frecuentes',
    announcement: 'Notificaciones',
    notice: 'Notificaciones',
    server_notice: 'anuncios de servidor',
    service_center: 'centro de servicio',
    profile: 'Información del miembro',
    company: 'empresa',
    account_management: 'Gestión de cuentas',
    do_exchange: 'para el intercambio',
    transfer: 'transferencias',
    look_up: 'referencia',
    faq: 'Preguntas frecuentes',
    server: 'servidor',
    email_request: 'Contacta',
    Product_Subscription: 'Producto y suscripción',
    easy_payment: 'Pago facil',
    easy_login: 'inicio de sesión fácil',
  },
  footer: {
    footer_msg:
      'Tome ventaja de las cuentas relacionadas con monedas en ONETETHER!',
    footer_sub_msg:
      'A través de nuestra ONETETHER por favor utilice las transacciones y servicios de cartera',
    footer_sub_msg2: 'punta',
    footer_sub_msg3: 'ONETETHER puede soportar todos los ambientes.',
    ICO: 'ICO',
    c2c: 'C2C Cambio',
    b2c: 'intercambios B2C',
    margin_exchange: 'del margen de cambio',
    gift_exchange: 'Bolsa de Futuros',
    Binary: 'Opciones Binarias',
    open_marcket: 'Mercado abierto',
    game: 'juegos',
    proceed: 'las transacciones en curso',
    public: 'OPI Noticias',
    direct_ex: 'El intercambio directo',
    buy: 'Comprar',
    sell: 'Comprar',
    buy_sell: 'Compra / Venta',
    holding_coin: 'monedas Holding',
    fee: 'Fee',
    exchange: 'intercambio',
    transfer_record: 'Historial de Trading',
    Leverage: 'apalancamiento',
    live_exchange: 'Trading en vivo',
    demo_exchange: 'Operaciones Demo',
    contest: 'manifestación',
    powerball: 'Powerball',
    law:
      'Jurídico: número de registro de ONETETHER.COM: 70638826927 (T 6 29 Ferrocarril Pde EastwoodNSW 2122)',
    law1:
      'Trading Point de los instrumentos financieros El propietario de la totalidad del Ltd (Australia) Pty Ltd es ONETETHER Número de registro: 70638826927 marca.',
    law2:
      'Este sitio está potenciado por ONETETHER Corp. ONETETHER Corp aprobado Nº 64190 - están bajo la regulación del servicio financiero auxiliar, que se ha registrado en el número de referencia 70638826927 Australia.',
    law3:
      'ONETETHER opera de acuerdo a los productos financieros directrices de inversión de Australia.',
    law4:
      'ref. no. 538324 | reg ABN. 70638826927 | reg BA. 64190. Para asegurarse de que está permitido el uso de los servicios de ONETETHER en las disposiciones legales del país de residencia es responsabilidad exclusiva del cliente.',
    law5: 'Por favor, lea la Declaración de Riesgos ONETETHER profesional FX.',
    law6:
      'ONETETHER no proporciona servicios a los Estados Unidos, Belice, Mauricio, Japón, Alberta, Columbia Británica, Quebec, Saskatchewan Los residentes de Saskatchewan, Haití, Surinam, Corea del Norte, Puerto Rico y la zona ocupada de Chipre.',
    law7:
      'Por favor refiérase a la parte reglamentaria del FAQ para más información. Por favor refiérase a nuestra Declaración de Riesgos.',
    law8:
      'Las áreas restringidas: Trading Point of Financial Instruments Ltd no proporciona la inversión y los servicios auxiliares a los países del tercer mundo y regiones.',
    law_warn: 'Advertencia de Riesgo:',
    law_1:
      'CFD tiene un alto riesgo y productos complejos rápidamente pierden su dinero debido al apalancamiento. 69.10% de los inversores individuales cuenta de que va a perder dinero cuando el comercio de CFD.',
    law_2:
      'Debe tener en cuenta si se puede aceptar el hecho de que comprende funciona el CFD, mayor es el riesgo de perder dinero. Por favor refiérase a nuestra Declaración de Riesgos.',
    alert_title: 'Nota y la Nota',
    coco_market: 'ONETETHER Mercado',
    ieo_market: 'IEO Mercado',
    news: 'Noticias',
    event: 'evento',
    platform_rental_title: 'alquiler de plataformas',
    education: 'educación',
    online_Academy: 'Academia Online',
    offline_Academy: 'Desconectado Academia',
    shopping_basket: 'cesta de la compra',
    best_product: 'Mejores tratos',
    order: 'orden',
    my_page_title: 'mi página',
    member_info_management: 'Administración de cuentas',
    order_management: 'Gestión de pedidos',
    my_question: 'mi pregunta',
    one_enquiry: '01:01 Contacto',
    community: 'comunidad',
    lotto: 'lotería Powerball',
    rock_event: 'rock Lugar',
    quiz_game: 'Juego de preguntas',
    ladder_game: 'Escalera',
    tetris: 'Tetris',
    split_lotto: 'Lotto dividida',
    day_Lottery: 'lotería diaria',
    attendance: 'control de asistencia',
    scoop_out: 'Empotrar',
    forum: 'foro',
  },
  main_msg: {
    about_1_title:
      'El mejor mundo de los servicios de comercio de divisas contraseñas',
    about_1_msg:
      'Todos los servicios relacionados con la moneda que lleva ONETETHER.',
    about_1_1_msg:
      'Disponible para la primera moneda criptomoneda tiempo, las ventas en un solo lugar en el mundo.',
    about_1_2_msg:
      'En cuanto al intercambio directo que está disponible en ONETETHER.',
    about_2_title: 'Inmediatamente sistema de intercambio',
    about_2_msg:
      'ONETETHER utilizando una tecnología de concordancia estables multi-paralelo la aplicación inmediata de las tecnologías avanzadas de diseño para permitir Cambio Las acciones del sistema de Exchange.',
    about_3_title: 'Monedero generada',
    about_3_msg:
      'Los expertos en seguridad han sido ONETETHER está compuesto por los mejores ingenieros en Corea Equipado con sistema de seguridad del estado de la técnica ofrece sistema de monedero.',
    about_4_title: 'sistemas de comercio simples (C2C)',
    about_4_msg:
      'ONETETHER es la construcción de un simple sistema de comercio fácil de usarPermitamos que una operación más conveniente.',
    c2c_main_msg1_1:
      'ONETETHER intercambiará inmediatamente el uso de la tecnología de reconocimiento de múltiples paralelo confiable',
    c2c_main_msg1_2:
      'Mantenga el sistema de intercambio, la aplicación de las técnicas avanzadas de diseño para permitir y',
    c2c_main_msg1_3: 'Ahi esta.',
    c2c_main_msg2_1:
      'Los expertos en seguridad han sido ONETETHER está compuesto por los mejores ingenieros en Corea',
    c2c_main_msg2_2:
      'Equipado con sistema de seguridad del estado de la técnica proporciona el sistema Wallet.',
    c2c_main_msg3_1:
      'ONETETHER es más fácil sistema de comercio fácil de usar acumulación',
    c2c_main_msg3_2: 'Se permite una fácil negociar.',
  },
  toasted_msg: {
    agree_required_term: 'Acepta los términos y condiciones requeridos.',
    must_read_term: 'Debe leer o descargar todos los términos y condiciones.',
    confirm: 'Se ha identificado',
    changed: 'Cambios han sido',
    withdrawal: 'La retirada era',
    register: 'Se ha registrado.',
    delete: 'Se ha eliminado.',
    title: 'Notificaciones',
    exchange: 'El intercambio directo se ha procesado correctamente.',
    search: 'Fue visto.',
    deposit_request: 'La aplicación se ha depositado.',
    withdraw_request: 'La retirada ha estado aplicando.',
    create_account: 'Ha sido abierto.',
    modify: 'Se ha fijado.',
    cancel: 'Se ha cancelado.',
    trade_confirm: 'Comercio ha sido establecida.',
    trade_reject: 'Trato negó.',
    copy: 'Copiado.',
    nice_msg:
      'Si usted no tiene que estar deshabilitado en la configuración del navegador emergente de autenticación de identidad no proceder normalmente.',
    nice_title: 'información',
    nice_success: 'autenticación de identidad se ha procesado correctamente.',
    nice_error: 'No es posible verificar su identidad.',
    no_transfer: 'No hay intercambio de información.',
    email_auth:
      'autenticación de correo electrónico se ha realizado correctamente.',
    email_auth_send: 'Este correo electrónico fue enviado a la certificación.',
    kyc_withdraw: 'autenticación de cuentas se ha realizado correctamente.',
    not_allow_trade: 'Deal es inactiva.',
    id_find_mail_send: 'ID ha sido enviado por correo electrónico.',
    duplicate_check: 'ID duplicado o correo electrónico.',
    pay: 'El pago se ha completado.',
  },
  private: {
    deal_list: 'Historia ventas',
    app_list: 'historial de compras',
    deal_buy_asset: 'Activos para comprar',
    buy_price: 'El precio de compra',
    confirmed_source_amount: 'Confirmar las ventas',
    holding_source_amount: 'Las ventas no confirmados',
    potential_source_amount: 'Cantidad',
    direct_market: 'El intercambio directo',
    deal_enroll: 'Venta',
    app_enroll: 'para comprar',
    select_market: 'Selecciona mercado',
    fee_rate: 'comisión',
    deal_info_input: 'Introducir la información de ventas',
    deal_source_amount: 'venta',
    deal_price: 'Precio por unidad',
    deal_enroll_account: 'Cuenta para la Venta',
    account_select: 'Seleccionar cuenta',
    direct_asset_select:
      'Por favor, elija una venta de la propiedad y la compra',
    please_select_asset: 'Por favor seleccione un activo.',
    basic_rate: 'precio actual',
    direct_transfer_buy: 'compra inmediata',
    direct_transfer_sell: 'Inmediatamente en el momento de la venta',
    direct_source_amount: 'Unidad de Cambio de divisas',
    direct_target_amount: 'aplicar Cantidad',
    direct_asset_buy: 'Comprar {0}',
    direct_asset_sell: 'Las ventas a {0}',
    selected_deal_info: 'Selección de información sobre ventas',
    deal_source_asset_title: 'Los activos adquiridos',
    deal_total_source_amount: 'El volumen de ventas',
    app_info_input: 'Introducir la información de compra',
    app_amount: 'El volumen de compras',
    app_deal_price: 'Con un precio',
    pay_target_amount: 'Cantidad paga por hacer',
    fee: 'comisión',
    fee_calc: 'importe de la cuota',
    msg_fee_calc: 'Como {0} será deducido.',
    app_account: 'Dar cuenta de Compra',
    app_receive_account: 'Seleccionar cuenta para recibir',
    c2c_buy_select_asset: 'Por favor elige una compra de propiedad',
    go_home: 'Volver a la',
    buy_calc_spread: 'moneda de compra',
    sell_calc_spread: 'Venta de divisas',
    cs_market_asset: 'activos par',
    cs_market_basic_rate: 'tipo de referencia de marketing',
    transfer_type: 'Tipo de Cambio',
    exchange_rate: 'tipo de cambio',
    submit_transfer: 'intercambiar inmediatamente',
    deal_source_min_amount: 'La cantidad mínima de compra',
    closed_date: ', a uno',
    no_deal: 'No hay lista de ventas',
    app_price_per_quantity: 'Precio por unidad',
    app_fee_amount: 'honorarios totales',
    select_deal_app_list: 'Las compras de ventas seleccionados',
    no_select_deal_app_list: 'No hay compras en sus ventas',
    transfer_source_amount: 'Sobre la base de la cantidad de activos',
    transfer_target_amount: 'Para los activos Cantidad',
    transfer_basic_rate: 'tipo de referencia aplicado a la venta',
    transfer_spread_rate: 'los diferenciales de tipos de aplicaciones',
    transfer_exchange_rate: 'tipo de cambio',
    transfer_list_detail: 'Intercambio Solicitar más detalles',
    transfer_source_asset: 'Sobre la base de activos',
    transfer_target_asset: 'para los activos',
    transfer_source_account_number: 'Basado en el número de cuenta de activos',
    transfer_target_account_number: 'Para el número de cuenta de activos',
    transfer_detail_type: 'Tipo de Cambio',
    transfer_regdate: 'aplicar una',
    transfer_asset_info: '{0} a {1} {2}',
    transfer_asset_select:
      'Por favor, seleccione el recurso que desea reemplazar.',
    msg_transfer_buy: 'Comprar {0}',
    msg_transfer_sell: 'Las ventas a {0}',
    deal_fee_amount: 'honorarios partido de la venta de información impuestos',
  },
  wallet_page: {
    have_asset: 'bienes',
    asset_list: 'Lista de Activos',
    account_list: 'Lista de cuentas',
    account_create: 'La creación de cuentas',
    deposit: 'depósito',
    withdraw: 'retirada',
    deposit_list_look: 'depósito de búsqueda',
    deposit_look: 'Vistas de depósitos',
    withdraw_list_look: 'Historia y retirada',
    withdraw_look: 'Vistas de abstinencia',
    account_modify: 'cuenta Modificar',
    deposit_apply: 'Aplicación de depósito',
    withdraw_apply: 'solicitud retirada',
    deposit_request_amount: 'Monto del depósito',
    withdraw_request_amount: 'La retirada Cantidad',
    withdraw_account_info: 'La retirada información de la cuenta',
    holder_name: 'Nombre del titular de la cuenta',
    bank_name: 'Nombre del Banco',
    withdraw_bank_address: 'Número de cuenta',
    withdraw_address: 'dirección de la propiedad',
    qr_address: 'dirección de la cuenta',
    create_qr_address: 'Discurso de apertura de cuenta',
    account_enroll: 'registro de la cuenta',
    account_seq: 'número de identificación de la cuenta',
    account_title: 'Nombre de la cuenta',
    regdate: 'Gaeseolil',
    before_regdate: '(Antes de la apertura)',
    holding_balance: 'Detener la cantidad',
    select_asset: 'Seleccione la propiedad',
    create: 'abierto',
    deposit_list: 'depósito',
    no_deposit_list: 'No depositar historial de aplicaciones',
    deposit_apply_detail: 'Depósito solicitar más detalles',
    asset_title: 'baza',
    request_amount: 'monto solicitado',
    withdraw_list: 'Historia de retirada',
    no_withdraw_list: 'No hay solicitud de retiro.',
    withdraw_apply_detail: 'La retirada solicitar más detalles',
    withdraw_fee_total_amount: 'Retiro total (incluidas las tarifas)',
    net_amount: 'cantidad final',
    fee_type: 'tipo de tarifa',
    fee_charge_type: 'Fee charge type',
    amount_of_fee: 'Amount of fee',
    create_account_address: 'Discurso de apertura de cuenta',
    deposit_msg:
      'Depositar la cartera {0} {0} desde el exterior de la cartera.',
    deposit_msg_1:
      'Una vez aprobado 350 veces (confirmación) en el bloque de la cadena {0} transacciones se reflejan en la cartera.',
    deposit_step_1: 'PASO 1. Comprobación del ID {0} memos primero.',
    deposit_step_1_1: 'Mi notas ID {0}',
    deposit_step_1_2:
      '{0} debe marcar sus propias notas de identificación cuando usted deposita. {0}, sin notas de transferencia se pierde ID.',
    deposit_step_1_3: 'Ver su dirección de {0} Wallet.',
    deposit_step_1_btn: 'Notas Copia de ID',
    deposit_step_2: 'Paso 2. Verificar su dirección de cartera.',
    deposit_step_2_1: 'código QR',
    deposit_step_2_2: 'Monedero Dirección',
    deposit_step_2_3:
      'La cantidad de depósito mínimo es de <span style = "color: # 4a90e2"> {0} {1} es </ span>.',
    deposit_step_2_btn: 'Copiar dirección monedero',
    deposit_msg_2: 'Por favor, compruebe',
    deposit_msg_2_1: 'Esta dirección es la dirección de único depósito.',
    deposit_msg_2_2:
      'El tiempo total que se necesita para conformar la terminación puede verse afectada por la congestión de la red de la cadena de bloque, criptomoneda protagonizada por encadenamiento de bloques de congestión es <span style = "color: #4a90e2; cursor: pointer;"> aquí </span> se puede comprobar.',
    no_account_list: 'No hay lista de cuentas.',
    no_favorite_account_list: 'No hay detalles de la solicitud de depósito.',
    input_account: 'Por favor ingrese el nombre de su cuenta para cambiar.',
  },
  my_page: {
    my_profile: 'mi información',
    user_unique_num: 'Número de identificación de miembro',
    user_name: 'nombre de usuario',
    email_address: 'E-mail',
    register_regdate: 'desde',
    last_login: 'Último inicio de sesión',
    auth_complete: 'certificado',
    not_auth: 'sin certificar',
    expdate: 'caducidad',
    act_auth: 'de autenticación',
    realname_auth: 'autenticación de la identidad',
    email_auth: 'autenticación de correo electrónico',
    otp_auth: 'la autenticación OTP',
    enroll: 'registro',
    security: 'Nivel de seguridad',
    show_security: 'Ver Nivel de seguridad',
    auth_withdraw_address: 'Autenticación Dirección de retirada',
    apply_list: 'aplicar Historia',
    password_modify: 'Editar su contraseña',
    email_modify: 'Editar correo electrónico',
    account_block: 'cuenta retirada',
    placeholder_old_password: 'Por favor, introduzca su contraseña antigua',
    placeholder_new_password: 'Por favor, introduzca su nueva contraseña',
    placeholder_confirm: 'Por favor, introduzca de nuevo',
    placeholder_password: 'Por favor, introduzca su contraseña',
    placeholder_email: 'Introducir un nuevo correo electrónico',
    mail_cert_list: 'Historia aplicación de correo electrónico',
    no_mail_list: 'Sin antecedentes aplicación de correo electrónico.',
    nominee_detail: 'Historia del círculo fidicular',
  },
  kyc: {
    register_account: 'cuenta de registro',
    kyc_enroll: 'Las solicitudes de autenticación KYC',
    kyc_enroll_2: 'KYC comprobante de domicilio',
    kyc_enroll_3: 'KYC Razón para el ajuste ascendente de 4 pasos',
    auth: 'certificación',
    auth_code_send: 'Enviar el código de autenticación',
    auth_code: 'Código de autenticación',
    msg_auth_code:
      'Por favor, introduzca el código de verificación dentro de los 5 minutos.',
    type_title: 'Nombre del tipo de',
    withdraw_auth: 'Autenticación Dirección de retirada',
    withdraw_auth_tit:
      'Un procedimiento de autenticación de direcciones objetivas para deducción externa. Registre la cuenta de destino y la dirección de la billetera para que se compruebe.',
    select_asset: 'Seleccione la propiedad',
    select_bank: 'Seleccionar banco',
    holder_name: 'Nombre del titular de la cuenta',
    birth: 'fecha de 6 dígitos de nacimiento',
    address: 'dirección de la propiedad',
    withdraw_list: 'Cuenta Historial de la solicitud de retirada',
    bank_name: 'Nombre del Banco',
    withdraw_info: 'La retirada información de la cuenta',
    withdraw_complete: 'La propiedad ya se ha completado esta certificación.',
    regdate: 'sumado',
    delete_withdraw_address: 'dirección de débito cambiada',
    delete_success_address: 'La dirección de la retirada ha cambiado.',
    kyc_cert_list: 'KYC historial de aplicaciones',
    no_kyc_list: 'KYC hay antecedentes aplicación.',
    no_kyc_withdraw_address_list:
      'No hay una historia solicitud de cuenta de pago.',
    kyc_placeholder: 'Por favor escribe.',
  },
  otp: {
    enter_verification_number: 'Introduzca un número de autenticación OTP',
    otp_auth: 'la autenticación OTP',
    authenticode: 'Claves OTP',
    otp_deactivate: 'OTP con discapacidad',
    msg_authenticator_installation:
      'La aplicación "Google Authenticator", instale en su teléfono inteligente o en el escritorio',
    android: 'androide',
    or: 'o',
    iphone_series: 'iPhone, IPAD y el iPod',
    windows_phone: 'windows Phone',
    and: 'y',
    msg_microsoft_other_systems:
      'Otros sistemas, incluyendo escritorio de Microsoft Windows',
    msg_key: 'la clave',
    msg_use_loss_change:
      'Por favor, escriba en el papel. Perdido o terminal se utiliza cuando se necesita cambiar la OTP.',
    msg_brcode_touch:
      'Ejecutar la aplicación "Google Authenticator" precios Por favor tocando el <b> Escanear código de barras QR </ b> en la parte inferior de la pantalla.',
    msg_input_authenticode:
      'Por favor, introduzca el código de verificación que aparece en la pantalla del terminal en el "código de autenticación" a continuación.',
    otp_key: 'Claves OTP',
    otp_activate: 'la activación OTP',
    otp_copy: 'Las claves OTP copiados.',
    otp_safe_keeping:
      'Menos hizo la clave OTP en el papel y guárdelo en un lugar seguro?',
    yes: 'cuatro',
    otp_register: 'inscripción',
    otp_register_success: 'El registro OTP se completó con éxito.',
    otp_delete_success:
      'OTP cancelación del registro se ha realizado correctamente.',
    msg_click_key_copy: 'Haga clic en la tecla de copiado.',
    otp_login: 'Iniciar sesión OTP',
  },
  security: {
    show_security: 'Ver Nivel de seguridad',
    grade: 'clasificación',
    condition: 'condición',
    restriction: 'limitaciones',
    no_grade: 'Mudeunggeup',
    no: 'cualquier',
    security_title:
      'Limitaciones criterios de calificación de seguridad específica',
    banner1: 'Seguridad de confianza',
    banner2:
      'Para la compra o venta a través ONETETHER, ONETETHER debe asegurar el cifrado de datos, monitoreo de transacciones en tiempo real, la política de protección del comprador y el vendedor, y todos sus pagos a través de un esquema de ONETETHER recibido pago y envío y pago seguro.',
    banner_invite: 'ONETETHER no tienen una cuenta?',
    banner_join: 'Regístrese Gratis',
    banner3: 'Cómo ONETETHER está manteniendo a nuestros clientes seguros',
    content1_h3: 'Protección del comprador',
    content1_text:
      'Si el comprador ohbaesong desgaste o daño mibaesong, ONETETHER puede compensar la cantidad de pago total, incluyendo los gastos de envío de transacciones elegibles. *',
    content2_h3: 'Protección del vendedor',
    content2_text:
      'Si recibe un pago no autorizado o reclamaciones mibaesong contra el vendedor en la venta es elegible, puede obtener el importe total de la protección. *',
    content3_h3: 'cifrado de datos',
    content3_text:
      'conexiones TLS, HTTPS para ayudar a mantener el pago, fijando la tecla de aplicaciones móviles, el cumplimiento de PCI más seguro.',
    content3_btn: 'PCI Compliance',
    content4_h3: 'Prevención de fraude',
    content4_text:
      'Todas las transacciones son monitoreadas en tiempo real mediante el análisis de su cuenta y el apoyo para prevenir actividades fraudulentas y facturación.',
    sec_h2: 'Cheque Compre',
    sec_text:
      'ONETETHER porque el monitoreo de transacciones las 24 horas del día, los 365 días cuando se detecta algo diferente de lo habitual ponerse en contacto con el comprador le pide que confirme su nombre de usuario o la compra. También comprueba ONETETHER para todas las compras y ventas a través de correo electrónico.',
    wran_h2: 'Si encuentra un puntos sospechosos',
    warn_step1: 'Informe.',
    warn_step1_text1:
      'Después de confirmar los detalles no han encontrado un acuerdo aprobado',
    warn_step1_text2: 'Señalar un problema> Informe de actividad no autorizada',
    warn_step1_text3: 'Haga clic o contacto inmediato ONETETHER.',
    warn_step2: 'Compruebe si hay otros problemas.',
    warn_step2_text1:
      'Revisar los últimos ajustes de la actividad comercial y de cuenta para asegurarse de que los cargos adicionales o modificaciones, por favor, también informan de esta información.',
    warn_step3: 'Por favor, cambie su contraseña.',
    warn_step3_text1:
      'Se puede en los ajustes de la cuenta en el menú Seguridad. O, si usted no puede acceder a su cuenta',
    warn_step3_text2: 'Login> Problemas de registro',
    warn_step3_text3: 'Haga clic para obtener reinicio.',
    warn_btn: 'Reportar transacciones no autorizadas',
    online_h2: 'soportes ONETETHER Secure actividades en línea.',
    online_h3: 'Seguridad de la cuenta',
    online_text: 'Proteger su cuenta con una contraseña muy segura.',
    online_btn: 'más información',
    auth_incomplete: 'Certificado incompleto',
  },
  input: {
    id: 'Identificación de entrada',
    password:
      'una contraseña de entrada (8-32 dígitos con caracteres especiales)',
    repeat_password: 'Confirmar contraseña',
    user_name: 'Nombre de usuario de entrada',
    email_address: 'Introducir la dirección de correo electrónico',
  },
  oauth: {
    contact_msg:
      'Quiere tener acceso a la siguiente información en la aplicación {0}.',
    agree_msg:
      '{0} ¿Está de acuerdo que el acceso a {1} `s información personal?',
    agree_info:
      'La información proporcionada será utilizado / almacenado por un período de servicio para la identificación del usuario, estadísticas, cuentas vinculadas CS y similares. Información básica y proporcionar los elementos necesarios es la información que se debe proporcionar a utilizar los servicios ONETETHER.',
    agree_request: 'ofrendas',
    agree_msg2:
      'Una vez acordado, la información será manejada de acuerdo con los Términos y Condiciones y Política de Privacidad del servicio.',
    agree: 'llegar a un acuerdo',
  },
  pay_head_foot: {
    account_management: 'Gestión de cuentas',
    account_summary_views: 'Resumen de búsqueda de cuenta',
    fund: 'fondos',
    history: 'Historial de facturación',
    help: 'Ayuda',
    qa: 'contáctenos',
    fee: 'comisión',
    secure: 'seguridad',
    go_shop: 'compras',
    my_info: 'perfil',
    my_page: 'Configuración de la cuenta',
    out: 'finalizar la sesión',
    in: 'login',
    about: 'sobre',
    blog: 'blogs',
    employ: 'empleos',
    site_map: 'Mapa del sitio',
    developer: 'revelador',
    partner: 'socio',
    privacy_state: 'política de privacidad',
    usage: 'Condiciones de Uso',
    feed_back: 'realimentación',
    warn_to_consumer:
      'Notificación a los clientes: los dueños de los medios de pago prepago ONETETHER ⓒ ONETETHER no requiere la aprobación de la Autoridad de Supervisión Financiera de Australia. Por favor, lea cuidadosamente los términos y condiciones.',
  },
  continue: 'continuación',
  pay_home: {
    cocobank_title: 'ONETETHER Banco',
    platform: 'plataforma',
    platform_rental: 'El alquiler de plataformas',
    cocopay_is: 'ONETETHER es el crecimiento de la empresa',
    help: 'Ayudando.',
    home_banner_1:
      'La ampliación de la base de clientes potenciales en todo el mundo, y para facilitar la gestión de pagos,',
    home_banner_2:
      'Negocios vendedor de protección *, y permitir seguro comprar en el control del fraude 24/7.',
    home_banner_3: 'Usted puede tener éxito con mayor facilidad.',
    home_banner_warn:
      '* Términos y Condiciones se aplican al vendedor de protección. Por favor, consulte su contrato para obtener información sobre la elegibilidad.',
    home_banner_join: 'Únete ahora gratuitamente.',
    home_sec1_openShop: 'Puede abrir una tienda en ONETETHER.',
    home_sec1_btn: 'para hacer frente',
    home_sec2_h2: 'Obtener el método de pago deseado.',
    home_sec2_text1:
      'ONETETHER también puede recibir pagos en línea, móvil, e incluso un correo electrónico.',
    home_sec2_text2:
      'Si el ONETETHER vende en cualquier lugar que puede ayudar con el pago más fácil y más seguro.',
    home_sec2_online_pay: 'El pago en línea',
    home_sec2_online_text:
      'botones de pago para una fácil configuración ONETETHER disponible es muy útil cuando se reciben pagos en efectivo y pagos periódicos, donaciones, etc. Con ONETETHER Pedido, los clientes pueden realizar pagos de manera más rápida y sencilla.',
    home_sec2_online_more: 'Ver más sobre el pago en línea',
    home_sec2_voice_invoice: 'factura por correo electrónico',
    home_sec2_voice_text:
      'solicitud por correo electrónico fácil para el pago al profesional libre de la factura. clientes en el extranjero, así como están disponibles para los clientes que no están ONETETHER cuenta.',
    home_sec2_voice_more: 'Ver más sobre facturas por correo electrónico',
    home_sec2_exchange_pay: 'Realizar un pago en el intercambio',
    home_sec2_exchange_text:
      'Con el servicio integrado de billetera en el intercambio, puede recargar y comprar y vender monedas en cualquier intercambio de empresas asociadas.',
    home_sec2_exchange_more: 'Obtenga más información sobre el cobro de cambio',
    home_sec2_mobile_pay: 'Obtener los pagos móviles',
    home_sec2_mobile_text:
      'Las soluciones se optimizan automáticamente para móviles. Obtener mundo donde aún más fácil de pago a través de la página web móvil o las aplicaciones de Android y iOS.',
    home_sec2_mobile_more: 'Ver más sobre los pagos móviles',
    home_sec3_h2: 'Encuentra más trabajo con socios ONETETHER independientes.',
    home_sec3_global:
      'ONETETHER conectará las oportunidades más globales con los principales sitios independientes del mundo.',
    home_sec3_btn: 'Comprobación de ONETETHER independiente',
    home_sec4_h2: 'Es fácil empezar.',
    home_sec4_banner1:
      'Aprende todo lo necesario para empezar desde el centro de negocios ONETETHER.',
    home_sec4_banner2:
      'Unirse a la cuenta de empresa y verificar su dirección de correo electrónico',
    home_sec4_banner3: 'Certificada a la cuenta bancaria',
    home_sec4_banner4: 'Seleccione una solución de pago',
    home_sec5_h2:
      '¿Por qué los muchos operadores mundiales <br/>hacen ONETETHER confianza.',
    home_sec5_sub_text:
      'Debido a que es una excelente opción. ONETETHER le gustaría conectar con el vendedor de 25 llamadas al cliente al menos dos de cien millones de personas en más de 200 mercados en todo el mundo.',
    home_sec5_sub_text_1: 'Debido a que es una excelente opción.',
    home_sec5_sub_text_2:
      'ONETETHER le gustaría conectar con el vendedor de 25 llamadas al cliente al menos dos de cien millones de personas en más de 200 mercados en todo el mundo.',
    home_sec5_h3: 'Seguridad.',
    home_sec5_h3_sub1:
      'la determinación automática de estafa, las operaciones de vigilancia de 24 horas y el programa de protección de vendedor y el comprador para proteger su negocio y sus clientes.',
    home_sec5_h3_more: 'sobre el pago en línea',
    home_sec5_h31: 'El mundo utiliza.',
    home_sec5_h31_sub1:
      'En todo el mundo sin necesidad de introducir la información cada vez que realice un pago rápido. En 203 mercados en 26 monedas se puede pagar a través de tarjeta de crédito, tarjeta de débito o ONETETHER.',
    home_sec5_h31_more: 'sobre facturas por correo electrónico',
    home_sec5_h32: 'Rápido.',
    home_sec5_h32_sub1:
      'En la mayoría de los casos cuando un cliente se acredita el pago inmediato a su cuenta ONETETHER. banco cargadas o un pago al vendedor o uso libremente en cualquier lugar donde el pago ONETETHER posible.',
    home_sec5_h32_more: 'Ver más acerca de la venta de eBay',
    home_sec6_h2: 'estructura de tarifas simples',
    home_sec6_sub:
      'ONETETHER cobrará una tarifa sólo cuando las ventas realizadas. honorarios ONETETHER se fijan sobre la base de la ubicación del cliente y el importe de las ventas.',
    home_sec6_more: 'Ver más acerca de las tarifas',
    home_sec7_h2: 'Comunidad para la venta de Corea del Sur, LAB TCC',
    home_sec7_text1:
      'Instituto de Comercio Transfronterizo (TCC LAB) es una comunidad de comerciantes ONETETHER Corea (Corea del ONETETHER) patrocinado para el comercio electrónico en el extranjero habilitado.',
    home_sec7_text2:
      'TCC LAB está ayudando al negocio crezca compartir información a nivel mundial de la costa este, como las últimas tendencias, consejos y las mejores prácticas.',
    home_sec7_more: 'Aprender a tomar ventaja de la TCC LAB',
    home_sec8_h2: 'Cumplir con los socios de enclavamiento ONETETHER.',
    home_sec8_text1: 'Necesitar ayuda profesional para su negocio en línea?',
    home_sec8_text2:
      'Las soluciones de alojamiento Web, carro de compras, soluciones de comercio electrónico, como obras de avance ONETETHER un socio compró esta ayuda su negocio.',
    home_sec8_text3:
      'Encuentra ONETETHER un socio para mi negocio en este momento.',
    home_sec8_more: 'más Socios',
    home_sec9_h2: 'Convertirse en un vendedor global. Esto ONETETHER juntos.',
    home_sec9_h2_1: 'Convertirse en un vendedor global.',
    home_sec9_h2_2: 'Esto ONETETHER juntos.',
    home_sec9_btn: 'Ahora unirse a las cuentas de Corea',
    home_learn_h2: 'más información',
    home_learn_li1: 'Solución Web Pago',
    home_learn_li1_1: 'Pago estándar',
    home_learn_li1_2: 'ONETETHER Pedido',
    home_learn_li1_3: 'Comprar en eBay',
    home_learn_li1_4: 'Soluciones comparar',
    home_learn_li2: 'otros pagos',
    home_learn_li2_1: 'facturas por correo electrónico ONETETHER',
    home_learn_li2_2: 'Comercio móvil',
    home_learn_li2_3: 'Negocio para los pagos automáticos',
    home_learn_li2_4: 'ONETETHER de B2B',
    home_learn_li2_5: 'ONETETHER para independiente',
    home_learn_li3: 'ONETETHER configuración e integración',
    home_learn_li3_1: 'centro de negocios ONETETHER',
    home_learn_li3_2: 'ONETETHER Corea comunidad mercantil (TCC LAB)',
    home_learn_li3_3: 'Añadir ONETETHER ONETETHER al sitio',
    home_learn_li3_4: 'Echa un vistazo a la Guía Mejor Conjunto',
    home_learn_li3_5: 'revelador',
    home_learn_li3_6: 'socio',
    home_learn_li3_7: 'Cómo ONETETHER',
    home_learn_li4: 'Administrar mi cuenta',
    home_learn_li4_1: 'aplicaciones de negocios ONETETHER',
    home_learn_li4_2: 'Configuración de la cuenta de negocio',
    home_learn_li4_3: 'Programa de Protección del vendedor',
    home_learn_li4_4: 'Manejo de quejas de los clientes',
    home_learn_li4_5: 'Las devoluciones de cargo comprensión (de cargo)',
    home_learn_li4_6: 'restricciones a la cuenta comprensión',
    home_learn_li4_7: 'Consejos para la prevención del fraude',
    home_learn_li4_8: 'PCI Compliance',
  },
  pay_nav: {
    view_your_account: 'Ver toda su cuenta',
    account_summary_views: 'Resumen de búsqueda de cuenta',
  },
  pay_login: {
    secure_sub_title: 'Login y Seguridad',
    secure_my_profile: 'perfil',
    secure_update_complete:
      'El perfil ambiental y los ajustes se han actualizado.',
    secrue_suggest: 'Cada vez que nos informa de su experiencia.',
    search: 'recuperación',
    my_info: 'Información personal',
    update: 'actualización',
    e_mail: 'E-mail',
    default: 'información básica',
    call: 'teléfono',
    phone: '(Móvil)',
    pay_mobile: 'El pago móvil',
    trading: 'Toma y daca',
    password: 'contraseña',
    change: 'cambio',
    secure_qa: 'La pregunta de seguridad',
    staying: 'No cerrar sesión para compras más rápidas',
    edit: 'compilación',
    browse_manage:
      'Administrar el dispositivo seleccionado y el navegador para mantener el estado de inicio de sesión.',
    account_type: 'Tipos de cuenta',
    account_delete: 'cancelación de la cuenta',
    business: 'negocios',
    edit_email: 'Editar dirección de correo electrónico',
    change_email: 'Cambiar dirección de correo electrónico',
    update_email: 'Agregue su email',
    eamil_url: 'Dirección de correo electrónico',
    update_email_url: 'Añadir su dirección de correo electrónico',
    error_email:
      'Lo siento. El correo electrónico predeterminado no se puede editar.',
    confirm_new_email: 'Comprobar si hay nueva dirección de correo electrónico',
    change_mail: 'cambio de correo electrónico',
    confirm: 'confirmación',
    changing: 'cambio',
    deleting: 'supresión',
    reaming:
      'Existen actualmente dos de la dirección de correo electrónico asociada con su cuenta. Usted puede agregar más a 5 de correo electrónico.',
    qa_1: '¿Cuál es el nombre de la escuela primera asistido?',
    qa_2: '¿Cuál es el nombre de la primera mascota?',
    edit_phone: 'Editar un número de teléfono existente',
    korea: 'República de Corea',
    explanation:
      'Al añadir el número, confirmo que está de acuerdo para marcar automáticamente y recibir llamadas pregrabados y de texto en función de la razón de la autoridad para sumar dos números se describen en la política de privacidad. Las tarifas estándar pueden aplicar.',
    edit_phone_num: 'Cambiar el número de teléfono',
    edit_password: 'Cambiar contraseña',
    confirm_password: 'Compruebe su contraseña actual',
    new_passod: 'nueva contraseña',
    confirm_password_new: 'Confirmar nueva contraseña',
    secure_question: 'La pregunta de seguridad',
    secure_pick: 'preguntas de opción',
    secure_answer: 'respuesta',
    edit_browse:
      'Con ONETETHER One Touch se puede completar rápidamente el pago sin tener que registrarse en cada momento.',
    already_log: 'El registran en la máquina.',
    off_all: 'ONETETHER de un toque de descuento en todos sus dispositivos',
    support:
      'PayPal se ha comprometido a la satisfacción del cliente 100%. Si usted tiene un problema con su cuenta',
    support_center: 'Atención al cliente',
    support_text1: 'O comprobar el',
    support_text2: 'Por favor refiérase a.',
    support_warn:
      'Si cancela su cuenta, no se puede cancelar los registros de cuentas también desaparecerán y niveles de fiabilidad.',
  },
  help: {
    support_center: 'apoyo',
    resolution_center: 'Centro de Resolución de Disputas',
    qa_search: 'Buscar Preguntas más frecuentes',
    common_qa: 'preguntas generales',
    common_qa_1:
      "Qué `¿Por qué aparece un mensaje de error después de actualizar el estado de su pedido a través de los 'fondos de conseguir enlaces?",
    common_qa_2: '¿Cómo puedo retirar fondos de la cuenta de Corea ONETETHER?',
    common_qa_3:
      '¿Cómo puedo añadir una tarjeta de débito o tarjeta de crédito a mi cuenta ONETETHER?',
    common_qa_4:
      'ONETETHER He olvidado mi contraseña de la cuenta. ¿Cómo puedo restablecer mi contraseña?',
    common_qa_5: '¿Puedo ya cancelo enviado un pago del importe ONETETHER?',
    common_qa_6: '¿Cómo recibo pagos a través de ONETETHER?',
    common_qa_7: '¿Cómo se envía el pago a través de ONETETHER?',
    common_qa_8: '¿Cómo agrego una cuenta bancaria a la cuenta ONETETHER?',
    common_qa_9:
      '¿Cómo puedo comprobar la cuenta bancaria asociada a mi cuenta ONETETHER?',
    common_qa_10: '¿Cómo desactivo el límite de cuentas ONETETHER?',
    technical_support:
      'Suscribirse a las cuestiones técnicas y actualizaciones.',
    condition_cocopay: 'estado de vista ONETETHER',
    muliple_help: 'Más formas de obtener ayuda',
    trading_help: 'Para resolver tales problemas acuerdo',
    tex_center: 'Centro de impuestos',
    tex_help: 'Encuentra formas de impuestos y otros recursos',
    need_help: 'contáctenos',
    help_center: 'Contacto Atención al cliente',
    help_to_center: 'Contacto Atención al cliente',
    prepare: 'Próximamente.',
    fast_help:
      'Cuéntenos su problema para que podamos más rápidamente ayuda ONETETHER.',
    my_search: 'Buscar mi problema',
    common_problem: 'Problemas comunes',
    login_problem: 'problemas de acceso',
    unkown_charge: 'acceso no autorizado o reclamaciones desconocidas informe',
    send_money: 'Enviar dinero',
    get_fund: 'recibir dinero',
    withdraw_money: 'retirar dinero',
    pay_cancel: 'Pago o cancelar el pedido',
    pay_hold: 'Pendientes de pago o en espera',
    refund: 'Los reembolsos',
    pre_pament: 'pagos previamente aprobados',
    negative_balance: 'saldo negativo',
    account_qa_1:
      'ONETETHER retirar de mi cuenta el estado aunque se muestra como "completado" ¿Por qué es el dinero que no contiene una cuenta bancaria?',
    account_qa_2:
      '¿Cuál es la razón de mi ONETETHER retirada sigue siendo un estado "pendiente"?',
    account_qa_3: '¿Por qué estaba pendiente de mi retiro?',
    item_title: 'El acceso de cuenta y contraseña',
    item_title_2: 'Perfil de la cuenta y configuración',
  },
  business: {
    no_trade: 'No hay posibles mercados de cambio.',
    view_your_account: 'Ver toda su cuenta',
    available: 'disponible',
    calculate_late:
      'Mostraremos el activo actual del campo eléctrico CCF más importante.',
    payment_transfe: 'las transferencias de pago',
    exchange: 'cambio de divisas',
    currency_update: 'Añadir llamada',
    update_btn: 'botón más',
    currency_cal: 'Conversor de divisas',
    pay_default: 'Preferencias de pago',
    payment_send: 'Enviar o solicitud de pago',
    account_list: 'Lista de cuentas',
    no_alias: 'No hay alias',
    new_bank: 'Conecte el nuevo banco',
    card: 'tarjeta',
    new_card: 'Conectar la nueva tarjeta',
    credit: 'crédito',
    preference_payment: 'Elegir los métodos de pago en línea preferidos.',
    payment_tip:
      'Al hacer compras en línea o enviar el pago de bienes y servicios a través de este medio. Usted puede elegir en cualquier momento un método de pago diferente durante el pago.',
    payment_more: 'Aprender acerca de sus preferencias de pago',
    paymnet_changes: 'equilibrio ONETETHER',
    debit_card: 'Tarjeta de débito',
    currency_tip:
      'Si se agrega una moneda, todos los futuros pagos recibidos en esa moneda se acreditarán a los fondos apropiados. La moneda base se utiliza para enviar un pago pago o petición.',
    currency_1: 'Dólar australiano',
    currency_2: 'Franco suizo',
    currency_3: 'Corona checa',
    currency_4: 'danesa',
    currency_5: 'euro',
    currency_6: 'libra británica',
    currency_7: 'Dólar de Hong Kong',
    currency_8: 'florín',
    currency_9: 'Nuevo Shekel Israelí',
    currency_10: 'peso mejicano',
    currency_11: 'Noruega Krone',
    currency_12: 'dólar de Nueva Zelanda',
    currency_13: 'Peso filipino',
    currency_14: 'Zloty polaco',
    currency_15: 'Rublo ruso',
    currency_16: 'Corona sueca',
    currency_17: 'Dólar de Singapur',
    currency_18: 'baht',
    currency_19: 'Nuevo dólar de Taiwán',
    withdraw_account: 'cuenta retirada',
    exchanged: 'Después de cambio de divisas',
    exchange_rate: 'Cotizaciones',
    exchange_tip:
      'El tipo de cambio es una cantidad estimada en base a la tasa de cambio actual, la tasa de cambio, se incluye en el ONETETHER.',
    currency_default:
      '(A) El yen japonés se establece en la moneda por defecto.',
    currency_default_notice:
      'La moneda base se utiliza para enviar un pago pago o petición.',
    currency_default_notice2:
      'El cierre de la llamada no se muestra en el balance no recibe ningún pago a la llamada.',
    currency_default2: 'JPY (s), el valor predeterminado',
    currency_quit_jp_btn: 'Cerrar Dólares',
    currency_quit_btn: 'Cerrar la palabra',
    bank_account: 'cuentas',
    bank_account_create_day: 'Gaeseolil',
    bank_account_change: 'saldos',
    bank_account_check: 'confirmando Banco',
    bank_account_remove: 'Banco de borrado',
    bank_continue: '¿Quieres continuar?',
    bank_tip:
      'Las transacciones pendientes con los bancos se procesan después de la eliminación.',
    bank_this_delete: 'Banco de borrado',
    card_tip:
      'La cuenta ONETETHER desea utilizarlo sin tener que gastar o límites de retiro?',
    card_confirm: 'Compruebe la tarjeta.',
    card_type: 'tipo',
    expiry_date: 'caducidad',
    card_adress: 'Dirección de facturación',
    card_update: 'tarjeta de actualización',
    card_delete: 'tarjeta de borrado',
    card_this_delete: 'tarjeta de borrado',
    card_tip2:
      'Actualmente se prefiere este método de pago. Una vez completado, se puede establecer un método de pago preferido diferente. Trato está pendiente con (a) no definido tratada después de la eliminación.',
    secure_code: 'Código de seguridad',
  },
  shop: {
    shop_list: 'Lista de almacenamiento',
    shop_create: 'tienda creada',
    shop_cre_date: 'sumado',
    shop_title: 'Nombre de la tienda',
    shop_id: 'ID de tienda',
    shop_state: 'estado',
    shop_work: 'trabajo',
    shop_detail: 'más',
    shop_retouch: 'cristal',
    shop_settlement: 'Solución de lista de cuentas',
    shop_history: 'transacciones',
    no_shop_list: 'No hay una lista de tiendas',
  },
  merchant: {
    create: 'tienda de registro',
    update: 'registro',
    retouch: 'tiendas modificados',
  },
  pay_legal: {
    service_usage: 'ONETETHER Condiciones del servicio',
    detail_usage:
      'Estos términos y condiciones se aplicarán a la región de Asia y el Pacífico, América Latina y algunos países de Europa, Oriente Medio y África usuarios. Para ver los términos y condiciones para los diferentes países o regiones, elegir de la lista a continuación.',
    nation: 'Seleccione un país',
    every_consumer: 'todos los usuarios',
    service_agree: 'Su contrato para el servicio ONETETHER',
    privacy_state: 'política de privacidad',
    purpose_policy: 'ONETETHER Política de Uso',
    payment_agreement: 'ONETETHER acuerdo método de pago alternativo',
    sell_buy: 'Comerciante y negocios',
    shop_policy: 'Políticas ONETETHER la ayuda del almacén',
    contract_profit: 'Contrato fines de lucro',
    billing_agreement: 'Acuerdo de pagos',
    direct_debit_agreement:
      'ONETETHER los fondos recibidos y los acuerdos de débito',
    additional_info: 'información adicional',
    infringement: 'Somyeongseo violaciónes de política',
    policy_update: 'Actualizaciones de la política',
    warn1:
      'Notificará a los consumidores: Servicio del pago ONETETHER es considerado como un medio de pago prepago (instalación de valor almacenado), de conformidad con la legislación australiana.',
    warn2:
      'ONETETHER los dueños de los medios de pago prepago ⓒ ONETETHER no requiere la aprobación de la Autoridad de Supervisión Financiera de Australia. También animamos a los consumidores (usuarios) se leen cuidadosamente estos términos y condiciones.',
    warn3:
      'Estas condiciones de uso y avisos proporcionan los términos y condiciones asociadas con un servicio de ONETETHER particulares.',
  },
  pay_privacy: {
    effective_day: 'Fecha de vigencia: 28 Marzo 2019',
    summary: 'resumen',
    personal_data: 'Los datos personales recogidos por ONETETHER',
    personal_date_cause: 'Razones para guardar su ONETETHER datos personales',
    summary_1: 'Nuestros usuarios son',
    summary_2: 'sitios',
    summary_3: 'o visita',
    summary_4: 'servicio',
    summary_5: 'Cuando se utiliza la década de los usuarios',
    summary_6: 'Los datos personales',
    summary_7:
      'Cómo recoger y almacenar, gestionar y compartir, explicando que la transferencia ha preparado esta política de privacidad. Esta política de privacidad se aplica a sus datos personales cuando visite nuestro sitio o utilizar el servicio, otra ONETETHER',
    summary_8: 'usuario',
    summary_9:
      'No se aplica a los sitios web o ONETETHER Web en línea que no sea propiedad o ajustes, incluyendo el sitio de servicio o servicio.',
    summary2_1:
      'ONETETHER puede visitar nuestros sitios o recopilar información personal cuando se utilizan los siguientes tipos de servicios.',
    summary2_2: 'Utilice Arriba e Información',
    summary2_3:
      'Cuando se suscribe a una cuenta para utilizar los servicios de ONETETHER, para cumplir con la información necesaria para recoger datos personales con el fin de prestar el servicio solicitado por el usuario.',
    summary2_4:
      'Dependiendo de los servicios seleccionados, puede pedir a proporcionar la información de identificación requerida para crear un nombre de usuario, dirección postal, número de teléfono, dirección de correo electrónico, cuenta.',
    summary2_5:
      'Condiciones le puede pedir a proporcionar datos personales adicionales, dependiendo del servicio.',
    summary3_1: 'la experiencia y la información sobre la negociación',
    summary3_2:
      'Utilizando los servicios de ONETETHER o si el acceso al sitio, por ejemplo, comprar por parte del vendedor, o la recepción de dinero o si el procesamiento de un pago o enviar dinero a amigos y familiares, a cobro revertido otra información relacionada con el comercio, así como la información de la transacción a partir ONETETHER el. Otra información relacionada con el comercio incluye el enviar o solicitar dinero, bienes o servicios de pago de dinero, el vendedor, incluyendo información acerca de todos los métodos de pago utilizados para completar la información y la información de la transacción dispositivo, datos de la tecnología, la información de ubicación, y similares.',
    summary4_1: 'Información del participante',
    summary4_2:
      'Al utilizar o acceder al servicio en el sitio ONETETHER recopila datos personales que los usuarios proporcionan a otros participantes involucrados en el acuerdo.',
    summary4_3: 'Para enviar o solicitud de dinero',
    summary4_4:
      'Si envía o solicitud de dinero a través del Servicio ONETETHER recoja su nombre, dirección postal, número de teléfono, datos personales, tales como recibir dinero de su información de cuenta financiera de la que envía el dinero a usted participante.',
    summary4_5:
      'El alcance de los datos personales solicitados en relación con los participantes puede variar dependiendo del servicio utilizado para enviar o solicitud de dinero.',
    summary5_1:
      'El pago de otras personas en lugar de las facturas o factura solicitando el pago a otra persona',
    summary5_2:
      'Si utiliza el servicio ONETETHER para pedirles que pagar la factura en nombre de otra persona, o pagar sus cuentas a su nombre a otro usuario, el nombre de usuario, dirección postal, número de teléfono, dirección de correo electrónico, la facturación del usuario en lugar de facturas u otros el titular de la cuenta debe reunir datos personales relevantes, incluyendo el número de cuenta que desea pagar en su lugar.',
    summary6_1: 'Añadir dinero a su cuenta',
    summary6_1_1: 'su cuenta',
    summary6_2:
      'Con el fin de agregar dinero a otras cuentas en la cuenta del usuario o el usuario puede poseer, o si utiliza el servicio ONETETHER a petición de ser añadido a la cantidad en esta cuenta a los demás usuarios de la otra cara del usuario para procesar eficientemente su solicitud recopilar información o puede obtener información sobre usted desde el otro lado.',
    summary6_3:
      'Por ejemplo, cargar o usar la solicitud de servicios de ONETETHER que se añade a la cantidad en la cuenta a un teléfono móvil, puede obtener otra información, incluyendo datos personales y número de cuenta móvil de los otros participantes.',
    summary7_1:
      'La información relativa a la persona en sus amigos y contactos',
    summary7_2:
      'Cuando el usuario se conecta la lista de contactos en su cuenta, es más fácil para dar ayuda a las personas frente a la hora ONETETHER con tus amigos y contactos. De manera que el usuario puede utilizar el dispositivo, o establecer una conexión entre las plataformas de medios sociales o dispositivos a cuentas ONETETHER o medios sociales cuando se conecta a la plataforma mejores servicios ONETETHER recogen y utilizan sus contactos de información de la lista (nombre, dirección, dirección de correo electrónico, etc.) en ONETETHER mejorar el medio ambiente.',
    summary8_1:
      'La información que usted decide proporcionar ONETETHER con el fin de utilizar ciertos servicios en línea o servicios adicionales',
    summary8_2:
      'Si la solicitud o participar en la selección del sitio para solicitar funcionalidades o mejora de los servicios, u otras características opcionales, puede obtener información adicional acerca de los usuarios en ONETETHER.',
    summary8_3:
      'Si los métodos utilizados para recopilar información de los servicios difieren de los expuestos en esta política de privacidad, la información recogida durante una notificación por separado.',
    summary9_1:
      'Información para el usuario al utilizar el servicio "ONETETHER no pago"',
    summary9_2:
      'Para algunos servicios limitados puede ser necesario iniciar sesión o usar la configuración de cuenta de la falta de pago. ONETETHER recogerá sus datos personales, todos los métodos de pago de información del dispositivo correspondiente, de tecnología, información de ubicación necesaria para el usuario para completar la transacción. Cuando se selecciona el propietario de la cuenta y el pago por la no negociación, se puede construir y recoger información de la transacción asociada con su cuenta.',
    summary9_3:
      'Si se utiliza el usuario, mientras que no es el propietario de la cuenta y seleccionar el pago por el trato no ONETETHER, recoger y almacenar toda la información que usted proporciona y compartida, de acuerdo con la información contenida en esta política de privacidad.',
    summary10_1: 'información específica del usuario obtenida de terceros',
    summary10_2:
      'De un tercero, como un comerciante, proveedores de datos, agencias de crédito en la medida permitida por la ley, se puede obtener la información.',
  },
  partner: {
    be_partner: 'Convertirse en un socio de ONETETHER.',
    banner_text:
      'Proveedor de la plataforma de compras, mercado, hay un operadores de soporte de facturación que requieren un proveedor de servicios de pago puede ser un socio de ONETETHER.',
    banner_btn: 'Para ponerse en contacto con su ejecutivo de cuenta',
    benefit: 'ONETETHER beneficios que los socios tienen derecho',
    benefit_1:
      'Integración y soporte técnico para la construcción de soluciones',
    benefit_2:
      'no dude en ponerse en contacto con nuestro equipo de soporte para que usted pueda obtener ayuda en la integración ONETETHER. portal de desarrolladores ONETETHER también puede ser utilizado como un recurso.',
    benefit_3:
      'El crecimiento del negocio a través de las oportunidades de comercialización',
    benefit_4:
      'Tomar ventaja de las muchas oportunidades de comercialización previstas ONETETHER puede atraer a los clientes potenciales.',
    traction: 'Y remolcar los pagos de todo el mundo.',
    traction1:
      'ONETETHER socios están apoyando una plataforma innovadora para una solución suave de los vendedores para ONETETHER confianza.',
    traction_btn: 'más Socios',
    program: 'Partner Program ONETETHER es libre de unirse.',
    program_1:
      'Por favor, rellene el formulario en línea, nos pondremos en contacto con usted en ONETETHER.',
    program_2:
      'Por favor describa las soluciones de negocio operativas y de funcionamiento.',
    program_3:
      'Por favor contacto ONETETHER para discutir los cambios necesarios.',
    program_4:
      'ONETETHER integrar con y ayuda a asegurar que reciban ONETETHER pago.',
    program_btn: 'Para ponerse en contacto con su ejecutivo de cuenta',
    common_qa: 'Preguntas más frecuentes',
    common_qa1: '¿Hay alguna pareja vendedores ONETETHER?',
    common_qa1_text:
      'Compañero ONETETHER es la empresa B2B (negocio a negocio) que ofrece a sus clientes soluciones ONETETHER. ONETETHER está trabajando con organizaciones como el carrito de la compra, las empresas de alojamiento web, desarrolladores web, proveedores de logística, y la agencia de marketing digital, pasarela de pago.',
    common_qa2: '¿Qué socios ONETETHER elegible?',
    common_qa2_text: 'Póngase en contacto con su ejecutivo de cuenta',
    common_qa2_text_2:
      'Usted puede obtener asesoramiento sobre las calificaciones de los socios.',
    common_qa3: 'Proporcionamos servicios de apoyo integrado en el ONETETHER?',
    common_qa3_text:
      'Una vez registrado en la aprobación del programa de socios e ONETETHER para unirse, puede acceder a los valiosos foros de documentación y desarrollo integradas. También puede obtener soporte integrado para consultores para el certificado.',
    common_qa4:
      'También hay un negocio fuera de Corea, me registro separado para cada país en el programa de socios?',
    common_qa4_text:
      'Depende del país en el que está operando un negocio. En ONETETHER están desplegando representante socio especializado a las necesidades regionales en varios países.',
    common_qa4_more: 'Ver Partner Program proporciona nacional',
  },
  pay_main: {
    total_product: 'producto total',
    total_sum: 'agregado',
    pay_this_account: 'Establecer esta cuenta como forma de pago.',
    bill_show:
      'La información de la transacción se muestra como sigue en la especificación.',
    banner_text: 'ONETETHER es más seguro',
    banner_text2: 'Un pago rápido.',
    banner_text3:
      'No importa dónde ir de compras va a mantener su información financiera segura.',
    footer_1: 'Términos y Condiciones',
    footer_2: 'Acuerdo de usuario',
    footer_3: 'política de privacidad',
    footer_4: 'realimentación',
    footer_5:
      'Notificación a los clientes: los dueños de los medios de pago prepago ONETETHER ⓒ ONETETHER no requiere la aprobación de la Autoridad de Supervisión Financiera de Australia.',
    footer_6: 'Condiciones de Uso',
    footer_7: 'Le invitamos a leer cuidadosamente.',
    footer_8: 'facturación',
    wallet: 'Monedero electrónico de gestión',
    last_name: 'sexo',
    card_number: 'Número de tarjeta',
    three_number: 'tres dígitos',
    name: 'nombre',
    pay_cocopay: 'Para pagar con ONETETHER',
    free_shipping:
      'Si la cuenta ONETETHER, se puede obtener el envío gratuito de vuelta, protección de la compra.',
    email_phone: 'Correo electrónico o número de teléfono',
    login_error: '¿Tiene problemas en la firma?',
    pay_card: 'El pago con tarjeta',
    cancel_back: 'Cancelar y volver a la página anterior',
  },
  site_map: {
    site_map_tip: 'Un vínculo que le ayudará a explorar la cuenta ONETETHER.',
    map_fund: 'fondos',
    map_fund_1: 'debitada',
    map_fund_2: 'Mi capacidad de utilizar el saldo es?',
    map_fund_3: 'Enviar o solicitud de dinero',
    map_fund_4: 'Gestión de llamadas',
    map_fund_5: 'ONETETHER mis descuentos de tarjetas de débito',
    map_fund_6: 'Obtener la tarjeta de débito ONETETHER',
    map_fund_7: 'Horario de facturación de crédito ONETETHER',
    map_deal: 'acuerdo',
    map_deal_1: 'Ver toda la actividad de ofertas',
    map_deal_2: 'Actividades vistas (incluyendo el equilibrio y tasas)',
    map_deal_3: 'Ver oferta gráficos y tablas',
    map_deal_4: 'Descargar reparto',
    map_deal_5: 'En respuesta a una reclamación o devolución de cargo',
    map_deal_6: 'IPN (Notificación de pago instantánea) Historia',
    map_profile: 'Mi perfil y Ajustes',
    map_profile_1: 'espejo de negocio',
    map_profile_2:
      'Correo electrónico, dirección, teléfono o contraseña actualización',
    map_profile_3: 'cuenta bancaria o tarjeta de actualización',
    map_profile_4: 'Notificaciones de actualización',
    map_profile_5: 'Límites de vista de la cuenta',
    map_profile_6: 'Gestión de usuarios',
    map_profile_7: 'Entrega Actualizar Preferencias',
    map_support: 'apoyo',
    map_support_1: 'Ir al Centro de Resolución de conflictos',
    map_support_2: 'Ir al Centro de Apoyo',
    map_support_3: 'contáctenos',
    map_support_4: 'información sobre las tarifas comerciante ONETETHER',
    map_report: 'informe',
    map_report_1: 'Informe para configurar, administrar o descargar',
    map_manage: 'instrumentos',
    map_manage_1: 'vista de herramientas',
    map_manage_2: 'gestión botón ONETETHER',
    map_manage_3: 'Gestión de Pago Regular',
    map_consum: 'cliente',
    map_consum_1: 'Ver lista de invitados',
  },
  fee: {
    fee_tip: 'Sencilla estructura de las tasas',
    fee_banner_1:
      'En general, la compra es libre y puede estar sujeto a tasas de cambio de divisas.',
    fee_banner_2:
      'Si las ventas no se pegan con las cuotas mensuales ONETETHER, o gastos de cancelación. Después de cada comisión sólo serán abonadas.',
    fee_h2: 'Por lo general compra es gratuita.',
    fee_text1:
      'Las tarifas para el procesamiento de pagos son pagados por el vendedor.',
    fee_text2: 'Sin embargo, se pueden intercambiar se aplica tarifa.',
    fee_more: 'tarifas de vendedor aprender más',
    fee_text3:
      'En venta por el sitio Web o el pago de factura por correo electrónico (se aplican tarifas estándar internacional de pago)',
    fee_text4: 'Existe un cargo fijo basado en la recepción de llamadas',
    fee_text5: 'las tasas de cambio pueden ocurrir de forma adicional.',
    fee_text6:
      'Por ejemplo, un recibo de pago de la cuota fija en USD es $ 0,30 USD.',
  },
  dash: {
    more: 'más',
    withdraw_asset: 'retiro de fondos',
    currency: 'moneda',
    quotes: 'Facturas y presupuestos',
    last_6_months: 'Últimos 6 meses',
    make_invoice: 'generación de facturas',
    manage_invoice: 'Gestión de facturas',
    grown_up: 'Por favor envíe hacer crecer el negocio para una cotización.',
    un_paid_invocie: 'facturas pendientes',
    make_quotes: 'la generación de cotizaciones',
    quotes_1: 'Se ha sugerido que las facturas pendientes.',
    quotes_2: 'factura ONETETHER',
    quotes_alarm: 'recordatorios de envío',
    quotes_detail: 'Mostrar más',
    quotes_who: 'Proyecto de ley para: Choi, tanto - Joven',
    latest_act: 'Actividad reciente',
    act: 'actividad',
    received: 'El pago recibido',
    send: 'De Pago',
    act_record: 'Actividad (incluyendo el equilibrio y honorarios)',
    pay_person: 'personas Biller',
    show_all: 'Ver todos',
    tell_us: 'Por favor, díganos su opinión.',
    feed_text:
      'Por favor tome un momento para decirnos su opinión sobre la información de la pantalla de nuevo diseño en esta página. Gracias!',
    service: 'proporcionar retroalimentación',
    feed_text_back:
      'Gracias por sus comentarios! ¿Era así como nuestro sitio es útil?',
    feed_placeholder:
      'Por favor, hágamelo saber la razón por la que vine hoy ONETETHER hay una manera mejor. No incluya información personal, como el correo electrónico o número de cuenta.',
    feed_p:
      'ONETETHER personal de la oficina y los huéspedes a sus comentarios pueden ser publicados internamente, por lo que se puede ver, no deje ninguna información personal. problemas de servicio al cliente, por favor haga clic aquí. de ONETETHER',
    feed_protect: 'política de privacidad',
    feed_law: 'Condiciones legales',
    feed_or: 'y',
    feed_need: 'ver',
    trade_name: 'nombre de la oferta',
    trade_id: 'ID de acuerdo',
    transaction_type: 'Tipo de trato',
    trade_amount: 'pago',
    detail_show: 'Look',
  },
  shop_detail: {
    detail_info: 'Detalles de la tienda',
    api_signature: 'Almacén de claves de firma',
    msg_shop_create: 'Esta tienda ha sido registrada.',
    msg_shop_modify: 'Esta tienda se ha solucionado.',
  },
  merchant_account: {
    create_account: 'Generar Cuenta de liquidación',
    enroll_account: 'Cuenta de liquidación de registro',
    pls_select_account: 'Elija Cuenta de liquidación',
  },
  transaction_detail: {
    transaction_title: 'trato detalles',
    order_id: 'Tienda Número de Orden',
    pay_account_title: 'Nombre de la cuenta de pago',
    pay_account_number: 'Número de cuenta de pago',
    pay_account_balance: 'Saldo de la cuenta de pago',
    pay_account_selection: 'Seleccione una cuenta para pagar.',
    pay_account_selection_msg: 'Seleccione una cuenta de pago.',
  },
  guide: {
    guide_title_1: 'Cuenta COCO',
    guide_title_2: '¿Cómo se realiza la transferencia y remesas de ONETETHER?',
    guide_title_3:
      'Aproveche el servicio más conveniente y seguro a través de la cuenta de Coco Bank.',
    guide_strapline_1:
      '① Cuentas que se pueden eliminar inmediatamente sin tarifa',
    guide_strapline_2: '② Fácil de abrir cuenta rápida de manera fácil',
    guide_strapline_3: 'Vestigio',
    guide_strapline_4: 'remesa',
    guide_strapline_5:
      'Cuentas que pueden depositar el mayor tipo de monedas en Corea.',
    guide_strapline_6: 'Cuenta segura de la piratería',
    guide_strapline_7: 'Consulta y recibo de historia visual disponible',
    guide_strapline_8:
      'Puede ser utilizado como una cuenta de liquidación corporativa.',
    guide_strapline_9:
      'Transacciones rápidas a través de cuentas para transacciones C2C y B2C.',
    guide_strapline_msg_1:
      'La transferencia de cuentas de ONETETHER no se produce para transferir dinero.',
    guide_strapline_msg_3:
      'La abertura de la cuenta de Coco Bank es de 10 segundos.',
    guide_strapline_msg_4: 'Proceso complejo omitido.',
    guide_strapline_msg_5:
      'Puede crear solo el nombre de la cuenta para ese activo.',
    guide_strapline_msg_6: 'Transferencia a través de billetera',
    guide_strapline_msg_7: 'Usando la dirección de la billetera',
    guide_strapline_msg_8: 'Cargos de tarifa',
    guide_strapline_msg_9: 'Remesa en Coco Bank',
    guide_strapline_msg_10: 'Usando el número de cuenta',
    guide_strapline_msg_11: 'Punto cero',
    guide_strapline_msg_12:
      'Muchos tipos de acumulaciones criptográficas se emiten en todo el mundo. Coco Bank está tratando con una variedad de acumulaciones criptográficas para ayudar a la comodidad del cliente de acuerdo con estos cambios.',
    guide_strapline_msg_13:
      'La seguridad es el núcleo de las inclusiones criptográficas. Coco Bank piensa que la seguridad más importante, y los ingenieros digitales con más de cinco años de experiencia en cada campo han establecido un sistema de seguridad.',
    guide_strapline_msg_14:
      'Puede consultar la transferencia entre cuentas. La cuenta de ONETETHER puede revisar los bancos entre bancos u otros bancos, como los bancos de mercado. Si es necesario, puede visitar el punto y verificar y emitir el historial de emisión.',
    guide_strapline_msg_15:
      'La cuenta de Coco Bank está vinculada a la cuenta de pago y liquidación del mercado de COCO. Después de registrar la cuenta criptográfica objetivo como una cuenta de liquidación, puede resolver los bienes vendidos en el mercado de ONETETHER a una criptopaste.',
    guide_strapline_msg_16:
      'Las tarifas y los retrasos se producen en la transacción entre el individuo a través de la billetera. Coco Bank ofrece remesas de cuenta bancaria de ONETETHER como una forma de resolver esto. Experimente las transacciones C2C y B2C sin cargo y retraso a través de la cuenta de ONETETHER.',
  },
  account_transfer: {
    transfer: 'Transferencia de cuenta',
    transfer_list: 'historial de transferencias',
    transfer_list_title: 'Transferencia de cuenta bancaria de COCO',
    transfer_list_wallet: 'Otra transferencia de billetera',
    msg_required_data: 'Por favor, rellene todos los valores',
    msg_not_select_withdraw_account: 'Por favor, seleccione la cuenta de pago',
    create_transfer_title: 'Transferencia de cuenta',
    from_account_select: 'Seleccione la cuenta de pago',
    available_transfer: 'montos de las transferencias',
    to_account_input: 'Transferencia de entrada número de cuenta',
    to_account_confirm: 'Transferir Verificación de cuenta',
    to_account_user_name: 'Transferencia de la cuenta Nombre de usuario',
    transfer_amount: 'Cantidad de la transferencia',
    delete_amount: 'corrección',
    all_amount: 'COMPLETO',
    description: 'explicación',
    transfer_btn: 'transferencias',
    transfer_info_check:
      'Compruebe la información de solicitud de transferencia',
    from_account_number: 'Número de cuenta de retirada',
    from_asset_title: 'Abstinencia activos de la cuenta',
    to_account_number: 'Transferir Número de cuenta',
    success_transfer: 'La transferencia se ha procesado correctamente.',
    transfer_list_detail: 'Historial de transferencias y',
    search_transfer_asset: 'Buscar por propiedad',
    search_transfer_account: 'Buscar por cuenta',
    reset: 'inicialización',
    search: 'recuperación',
    transfer_list_detail_tit: 'Transferir Detalles Detalles',
    no_transfer: 'No hay detalles de la transferencia',
    msg_not_search_account:
      'número de cuenta no existe o no es una entrada válida.',
    my_account_transfer: 'Mis transferencias de cuentas',
    msg_pls_select_account: 'Pärast vara valimist otsige kontolt.',
    placeholder_amount: 'Por favor, introduzca el importe de la transferencia',
    not_search_user_name: 'No estoy seguro de nombre de usuario',
    msg_select_asset_search: 'Por favor seleccione una cuenta',
    success_fail: 'La transferencia tuvo éxito.',
    pls_search_asset: 'Búsqueda de activos.',
    pls_search_account: 'Busca en tu cuenta.',
    pls_select_asset: 'Por favor seleccione un activo.',
    not_exist_account: 'La cuenta del activo no existe.',
    no_inquiry_history: 'No hay historial de consultas.',
    account_number_list_1: 'Hace 6 meses, no se puede consultar el débito.',
    account_number_list_2: 'El número máximo de vistas es de 6 meses.',
    account_number_list_3:
      'Presentar el resultado de la transferencia actual es una página que consulta que la consulta y la transferencia de comerciantes resulta en Coco Bank. <br /> Si desea ver los resultados de la transferencia con otros monederos, verifique la parte superior de la [transferencia de bolso] en la parte superior.',
    account_number_list_3_1:
      'La consulta de resultado de transferencia actual es una página para consultas dentro de ONETETHER y los resultados de transferencia de tiendas afiliadas. <br/> Si desea verificar el resultado de la transferencia a su cuenta de Cocobank, verifique la [Transferencia de la cuenta de ONETETHER] en la parte superior.',
    today: 'Día',
    one_week: '1 semana',
    one_month: '1 mes',
    three_months: '3 meses',
    six_months: '6 meses',
    withdrawal_account_number: 'Número de cuenta de retiro',
    withdrawable_amount: 'Monto disponible para retiro',
    recent_order: 'En orden más reciente',
    past_order: 'En orden pasado',
  },
  bank_service_center: {
    title: 'sujeto',
    date: 'fecha',
    state: 'estado',
    enter_search_word: 'Introduzca los términos de búsqueda',
    list: 'lista',
  },
  service_center: {
    view_all: 'Ver todos',
    contact_history: 'Consulta de historia',
    privacy_Statement: 'Política de manejo de información personal',
    would_you_agree: '¿Te gustaría estar de acuerdo con lo anterior?',
    mobile_number: 'Número de teléfono móvil',
    target_of_inquiry: 'Objeto de consulta',
    inquiry_contents: 'Contenido de la consulta',
    please_enter_your_inquiry: 'Por favor ingrese su consulta.',
    send: 'Enviar',
    normal_inquiries_received: 'Su consulta ha sido recibida con éxito.',
    inquiry_history: 'Consulta de historia',
    pls_select_inquiry_type: 'Por favor, seleccione el tipo de contacto',
    pls_login_to_use_inquiry: '1, sesión en las primeras investigaciones.',
    non_member_login: 'Inicio de sesión de no miembro',
    contact_id: 'Contacto ID',
    view_inquiry: 'Ver contacto',
    service_center: 'Servicio al cliente',
    inquiry_details: 'Detalles de contacto',
    msg_enter_title: 'Por favor, introduzca un título.',
    msg_enter_your_content: 'Por favor, introduzca su información.',
    msg_pls_login: 'Por favor inicio de sesión.',
    go_back: 'Ir hacia atrás',
    re_contact: 'material de los contactos',
    contents: 'contenido',
    msg_no_inquiry_history: 'No hay datos de contacto.',
    msg_require_login_additional_authentication:
      'Es necesario estar registrado o autenticación adicional.',
    when_you_member: 'Cuando uno de los miembros',
    msg_inquiry_history_can_view_after_login:
      'Los miembros de los datos de contacto se pueden ver después de iniciar sesión.',
    non_member: 'Cuando no miembros',
    lookup_inquiry: 'la búsqueda de contactos',
    msg_enter_inquiry_id: 'Por favor, introduzca el ID de contacto.',
    msg_enter_password_when_registering_your_inquiry:
      'Por favor, introduzca la contraseña que estableció cuando se llama registro.',
    frequently_asked_questions: 'Preguntas más frecuentes',
    msg_enter_your_password: 'Por favor, introduzca su contraseña.',
    pls_search_fap: 'Consulta las preguntas.',
    msg_source_filename_none: 'No hay imagen adjunta.',
    super_inquiry: 'Parte superior',
  },
  modal: {
    not_seeing_day: 'No se ve durante el día.',
  },
  login_guide_modal: {
    title: 'Informacion',
    sub_title:
      'El sistema de inicio de sesión se renovará para que los miembros utilicen el intercambio sin problemas.',
    content:
      '[Antes del cambio] <br/> ID de inicio de sesión creado cuando se registra por primera vez <br/><br/> [Después del cambio] <br/> Cambiar a su número de teléfono o correo electrónico de inicio de sesión <br/><br/> Para iniciar sesión hasta que se reorganice el sistema de inicio de sesión, simplemente inicie sesión con la ID que creó cuando se registró por primera vez.',
  },
  affiliate: {
    affiliate_occur_list: 'Historial de subsidios',
    affiliate_adjust_list: 'Detalles de liquidación de subsidios',
    allowance_balance_asset: 'Saldo de provisión por activo',
    list_allowance_balance_asset: 'Lista del saldo de la provisión por activo',
    search_by_asset: 'Buscar por activo',
    allowance_search: 'Búsqueda de subsidio',
    generator: 'Generador',
    beneficiary: 'Beneficiaria',
    benefactor: 'Benefactora',
    behavior_type: 'Tipo de comportamiento',
    target_unique_number: 'Número único objetivo',
    date_of_occurrence: 'Fecha de ocurrencia',
    application_policy_name: 'Nombre de la política de aplicación',
    beneficiary_type: 'Tipo de beneficiario',
    benefactor_type: 'Tipo benefactor',
    target_amount: 'Cantidad objetivo',
    principal_amount: 'Cantidad principal',
    allowance: 'Pago extra',
    allowance_assets: 'Activos de provisión',
    allowance_amount: 'Importe de la asignación',
    affiliate_log: 'Desglose de la asignación',
    allowance_settlement: 'Liquidación de subsidios',
    allowance_settlement_info: 'Información de liquidación de subsidios',
    name_asset_settled: 'Nombre de los activos a liquida',
    balance_receive_payment: 'Saldo a pagar',
    select_account_settled: 'Seleccione cuenta a liquidar',
    no_affiliate_log: 'No hay ningún subsidio incurrido.',
    no_affiliate_balance: 'No hay una lista de saldos de provisión por activo.',
    no_affiliate_adjust: 'No hay historial de pago de subsidio.',
    asset_name: '자Nombre del activo산명',
    asset_code: 'Código de activo',
    balance: 'Equilibrar',
    cumulative_amount: 'Cantidad acumulada',
    please_select_account: 'Por favor seleccione una cuenta',
    calculate: 'Calcular',
    settle: 'Asentar',
    calculate_amount: 'Cantidad fijada',
    account_number: 'Número de cuenta',
    registration_date: 'Fecha de Registro',
    number: 'número',
  },
  coin_name: 'Nombre de la moneda',
  main_function: 'Función principal',
  disclosure_ing: 'En medio de algo',
  quick_service: 'servicio rápido',
  new_account: 'cuenta nueva',
  social_login: 'Iniciar social',
  way_to_find: 'método de búsqueda',
  cocobank_korea_head_office: 'Sede de ONETETHER en Corea',
  cocobank_branch_office: 'Sucursal ONETETHER Shinsa',
  address_head_office: '528 Eonju-ro, Gangnam-gu, Seúl',
  address_branch_office: '803 Nonhyeon-ro, Gangnam-gu, Seúl',
  map: 'mapear',
  korean_language_counseling: 'consulta coreana',
  hours_of_business: 'Corea del Sur de 10:00 a 19:00 p.m.,',
  overseas_consultation: 'consulta en el extranjero',
  email_consultation: 'Consulta por correo electrónico',
  exchange_price: 'precio de cambio',
  market_price_check: 'mutualidad de precios del mercado',
  full_account_inquiry: 'consulta de cuenta completa',
  exchange_details_check: 'verificación de detalles de cambio',
  cryptocurrency_exchange_history: 'Historial de cambio de moneda',
  deposit_account_inquiry: 'consulta de cuenta de depósito',
  dormant_account_check: 'Mis amigos y yo nos reunimos.',
  account_and_other_case_status: 'Compruebe la cuenta COBANK y otros casos.',
  account_and_other_wallet:
    'Cuenta de ONETETHER y otras consultas de billetera',
  account_search: 'Búsqueda de cuenta ONETETHER',
  other_wallet_search: 'Otras transferencias de billetera',
  error_remittance: 'moción de devolución de ONETETHER',
  transfer: 'transferir',
  transfer_result_check: 'Consulta de resultado de transferencia',
  other_wallets_transfer: 'transferencia de otras billeteras',
  other_wallets_transfer_search: 'Búsqueda de otras transferencias de bolsos.',
  frequently_used_accounts: 'cuentas de uso frecuente',
  new_demand_account: 'Nueva cuenta de demanda',
  new_installment_savings_account: 'Nueva cuenta de ahorro a plazos',
  new_deposit_account: 'Nueva cuenta de depósito a plazo',
  check_account_progress_account:
    'Verificar el estado de progreso de la nueva cuenta',
  download: 'descargar',
  withdrawal: 'Retirada',
  Smart_window_withdrawal: 'Ventana inteligente de retirada',
  smart_ATM_withdrawal: 'Retiro de cajero automático inteligente',
  customer_service: 'Servicio al Cliente',
  notice: 'aviso',
  one_one_inquiry: 'Consulta 1: 1',
  inquiry_details: 'Detalles de la Consulta',
  frequently_asked_questions: 'Preguntas frecuentes',
  server_notice: 'Aviso del servidor',
  service_hours:
    'Horas de funcionamiento del servicio de satisfacción del cliente',
  all_day_long: '(Consultas las 24 horas disponibles)',
  online_service_hours: ' Horas de uso de ONETETHER online',
  unusable_hours:
    '24 horas al día, 7 días a la semana (23: 30-24: 00 no disponible)',
  offline_hours: 'Horas de uso bancario sin conexión',
  offline_bank_hours: '(excepto fines de semana y festivos)',

  management: 'administración',
  secure_management: 'Autenticación / gestión segura',
  fund_limit_management: 'Gestión de límite de fondos',
  issue_details_check: 'Verificación de detalles del problema',
  part_of_news: 'Esta es la parte de las noticias.',
  part_of_notice: 'Esta es la parte del anuncio.',
  full_menu: 'Menú completo',
  individual: 'individual',
  key_coin:
    'Moneda clave de ONETETHER que conecta la criptomoneda con la moneda real',
  limitation_info:
    'Información sobre restricciones de límites para prevenir daños al fraude financiero de telecomunicaciones',
  limitation_info_1:
    'Como una cuenta de pago a la vista se abre de manera no presencial, el límite de retiro (transferencia) a través de dispositivos automatizados e Internet se limita a {0} CCF por día.',
  limitation_info_2:
    'Los datos de autenticación objetiva para confirmar el propósito de la transacción se pueden presentar en la sucursal y el límite se puede levantar en “Administración> Autenticación / Administración de seguridad”.',
  limitation_info_3:
    'Al utilizar la banca por Internet, debe registrarse con una cuenta de retiro para realizar una transacción de transferencia.',
  limitation_info_4:
    'Solo se pueden abrir 5 cuentas por límite de criptomonedas.',
  limitation_notice: 'aviso',
  limitation_notice_1:
    'La suscripción a la banca por Internet se puede aplicar vinculando desde la pantalla de finalización después de abrir una cuenta de depósito y retiro.',
  limitation_notice_2:
    'Tenga en cuenta que los clientes de banca por Internet existentes pueden registrarse para cuentas de retiro a través de la banca por Internet solo cuando la categoría de registro de cuenta de retiro es Internet + sucursal.',
  limitation_notice_3:
    'Debe ser una autenticación segura para asegurarse de que es más fácil realizar su transferencia a la banca por Internet. Después del proceso de certificación, mejore la calificación y continúe con la contabilidad y la disposición del sistema contable.',
  new_subscription: 'Nuevo registro',
  new_subscription1_1:
    'Cuando haga clic en el botón de registro nuevo, se le emitirá su propia cuenta ',
  new_subscription1_2:
    'ONETETHER y la dirección de depósito vinculada a la billetera externa.',
  new_subscription2_1:
    '¡Asegúrese de saberlo antes de depositar! No hay tarifas si transfiere dinero desde una cuenta dedicada a ONETETHER a su cuenta. Solo ',
  new_subscription2_2:
    'se puede depositar en la cuenta / dirección emitida al registrarse nuevamente. Cualquier error / pérdida que pueda ocurrir si intenta depositar otros activos digitales en la dirección es irrecuperable. Después de que se haya producido 1 confirmación, se refleja en el saldo a través del proceso de depósito. El proceso de depósito es automático y el tiempo requerido puede variar según las condiciones de la red. La dirección anterior es solo para depósito.',
  new_subscription3_1: 'Puede depositar',
  new_subscription3_2: 'con una nueva suscripción que se le asigne.',
  new_subscription4: '¿Estuvo de acuerdo y comprendió lo anterior?',

  created_account_number: 'Número de cuenta creado',
  cocobank_exclusive_account: 'Número de cuenta exclusivo de ONETETHER',
  depositing_external_wallet:
    'Al depositar ONETETHER desde una billetera externa',
  use: 'Usar',
  we_future: 'nuestro futuro',
  pop_cocobank: 'BANCO DE COCO',
  fourth_industry: 'Líder en la cuarta industria',
  oc_15: '15 de octubre',
  officially_open: 'Oficialmente abierta!',
  head_branch_office:
    'Oficina central de Corea (sucursal de Jamsil) / primera sucursal (sucursal de Sinsa)',
  sep_15: '15 de septiembre a las 17 h',
  open_popup: 'Abierto',
  thanks_for: 'Gracias por tus ánimos.',

  direct_exchange: {
    sell_buy_assets: 'Activos para vender y comprar',
    replace_assets: 'Activo a reemplazar',
    ccm_exchange_rate: 'CCM con tipo de cambio preferencial',
    buy_sell_percent: 'Compra -10% Vende + 10%',
    expected_property: 'Propiedad esperada',
    preferential_property: 'Activos preferidos',
  },

  event_banner: {
    clap:
      'Bewahren Sie die Verschlüsselungsgelder in <span class="color-common">CLAP</span> von der ONETETHER.',
    month_hotcoupon: 'Consulte el Cupón CALIENTE de este mes.',
    hotcoupon_sub: '¡Desde tipos de cambio hasta varios cupones de afiliados!',
    grab_bug: 'Atrapa el error',
    grab_bug_sub:
      'Deje una consulta 1: 1. Los premios se entregan mediante lotería.',
    event2_sub_title: 'Tasas más altas.<br>Rendimientos aún mayores.',
    event2_title: '',
    event2_text: '¡Hágase miembro del CCM y reciba un dividendo!',
    event2_btn: 'Regístrate',
  },
  news_lists: {
    news_list_1:
      '프라비코, iq옵션과 같은 방대한 트렌젝션을 일으키는 거래소가 될 것',
    news_list_2:
      'GCC 코인 10월 15일 포블게이트에 상장. 비트코인처럼 안정화 된 코인이 목표',
    news_list_3: '프라비코, 의료산업에 블록체인 기술 접목한다',
    news_list_4: '디파이 열풍! 그 명과 암',
    news_list_5:
      '은행을 대체할 수 있을까? 블록체인 보관과 검증은 어떻게 이루어지나',
    news_list_6: '블록체인은 식품 유통에 혁신적인 발전을 가져올 것이다',
    news_list_7: '가장 혁명적인 화폐 비트코인 탄생 배경은?',
  },
  pop_notice: {
    notice_close: 'cerrar',
    notice_today: 'Sin ver hoy',
  },
  clap: {
    getting_started_clap: 'Método de configuración inicial',
    how_to_initialize_clap: 'Cómo reiniciar',
    getting_started_ledger_live: 'Cómo configurar Ledger Live',
    install_coin_app: 'Vinculación de la aplicación de monedas',
    start_text_1:
      '1. Después de conectar el CLAP y el conector USB adjunto a la computadora, verifique la frase "Bienvenido" para confirmar que es un producto nuevo.',
    start_text_2:
      '2. Presione el botón derecho y cuando aparezca el mensaje "Configurar como nuevo dispositivo", presione los dos botones en la parte superior al mismo tiempo.',
    start_text_3:
      '3. Después de confirmar la frase “Elegir código PIN”, aparece una pantalla para ingresar un código PIN de 8 dígitos. Presione ambos botones para configurar el código PIN.',
    start_text_4:
      '4. Cuando se completa la configuración del código PIN, aparece el mensaje Confirmar código PIN. Ingrese el código PIN nuevamente presionando ambos botones.',
    start_text_5:
      '5. Cuando se complete la configuración del código PIN, presione el botón derecho para mostrar la primera frase de 24 frases. Escriba el código en la parte posterior de la Tarjeta de restauración importante de acuerdo con el número en la pantalla.',
    start_text_6:
      '6. Cuando se complete la escritura, ingrese los códigos de restauración del 1 al 24 que coincidan con los números uno por uno.',
    start_text_7:
      '7. Cuando aparezca el mensaje Presione ambos botones para continuar, presione ambos botones en la parte superior para continuar.',
    init_text_1:
      '1. Antes de inicializar, primero verifique si tiene una tarjeta de recuperación y un código de recuperación importantes.',
    init_text_2:
      '2. Hay dos formas de inicializar. Primero, si CLAP está conectado a la PC y el código PIN es incorrecto 3 veces seguidas, se inicializa automáticamente.',
    init_text_3:
      '3. En segundo lugar, conecte el CLAP a la PC e ingrese el código PIN para desbloquear. Luego vaya a Configuración> Seguridad> Restablecer todo en orden.',
    init_text_4:
      '4. Presione Reiniciar todo nuevamente entre Cancelar y Reiniciar todo para continuar con la inicialización.',
    init_text_5: '5. Ingrese el código PIN para completar la inicialización.',
    init_text_6: '6. La inicialización está completa.',
    ledger_live_text_1:
      '1. Ingrese start.ledgerwallet.com en la barra de direcciones de Internet.',
    ledger_live_text_2:
      '2. Haga clic en la aplicación Ledger Live en el Paso 1 para instalar la aplicación para su dispositivo móvil o PC.',
    ledger_live_text_3:
      '3. Cuando aparezca el mensaje Bienvenido a Ledger Live, haga clic en Comenzar para continuar.',
    ledger_live_text_4:
      '4. Se le presentarán 4 opciones. Si está comprando un nuevo CLAP y continúa con él, puede seleccionar el No. 1 y los demás se pueden seleccionar según su situación.',
    ledger_live_text_5:
      '5. Presione 3 cuando se complete la configuración inicial para continuar.',
    ledger_live_text_6:
      '6. Seleccione el Ledger Nano S de las tres opciones y presione continuar.',
    ledger_live_text_7:
      '7. Hay tres listas de verificación. Configúrelo de acuerdo con su situación actual.',
    ledger_live_text_8:
      '8. Después de verificar la lista de verificación, haga clic en el tercer botón Verificar ahora.',
    ledger_live_text_9:
      '9. Conecte el CLAP a la computadora y desbloquee el CLAP. (Este es el proceso de verificación de autenticidad)',
    ledger_live_text_10:
      '10. Si su dispositivo es genuino en la tercera lista de verificación, haga clic en continuar en la parte inferior derecha.',
    ledger_live_text_11:
      '11. Aparece la página de configuración de la contraseña. Puede establecer una contraseña o no. Si desea establecer una contraseña, haga clic en Continuar / Omitir este paso en la parte inferior derecha después de ingresarla.',
    ledger_live_text_12:
      '12. Haga clic en continuar en la parte inferior derecha para continuar.',
    ledger_live_text_13: '13. La configuración de Ledger Live está completa.',
    coin_app_text_1:
      '1. Encienda el Ledger Live instalado anteriormente y haga clic en Ir al administrador en el centro.',
    coin_app_text_2: '2. Conecte CLAP a la PC e ingrese el CÓDIGO PIN',
    coin_app_text_3:
      '3. Cuando haya ingresado el CÓDIGO PIN, presione ambos botones superiores al mismo tiempo para continuar.',
    coin_app_text_4:
      '4. Busque la criptomoneda que tiene en la parte inferior y haga clic en Instalar a la derecha para vincular.',
    detail_to_buy: 'oficina de detalles y compras',
    detail_content1_1:
      'Clap tiene sentido que la cartera de cifrado del usuario está configurada para garantizar que el activo se mantenga de manera segura.',
    detail_content1_2:
      'La industria financiera global se está moviendo rápidamente a través del descubrimiento y la innovación de las nuevas tecnologías. Las criptures también cambiaron y aplicaron de acuerdo con estos cambios, y muchas compañías globales han estado prestando atención una vez más sobre el valor del Crypto.',
    detail_content1_3:
      'Los usuarios a largo plazo tienen más problemas en la seguridad de los activos debido a la naturaleza del cifrado que se usa solo en forma de información en una computadora.',
    detail_title_2: 'El servicio proporcionado por el clap está seguro.',
    detail_content2_1:
      'Coco Bank juzgó que una softwallette que almacena las llaves privadas en la nube es vulnerable a hacks externos, y se producirá un problema de seguridad. Sugerimos resolver el clap de la billetera de resolución que complementa estos problemas.',
    detail_content2_2:
      'Clap admite hasta ocho aplicaciones y puede mantener una variedad de cifras, como monedas, frente y pedidos de bits. También puede mantener activos de forma segura a partir de hacks externos porque no es una billetera que no siempre está conectada a Internet.',
    detail_title_3: 'Seguridad',
    detail_content3_1:
      'Clap es una colaboración (cartera de frío), una colaboración con "libro mayor" y colaboración con una compañía de soluciones de seguridad profesional de cifrado global para resolver los problemas de seguridad de una pared caliente (billetera caliente).',
    detail_content3_2:
      'La CLAP ha sido aplicada por una solución de seguridad que ha sido construida por 130 ingenieros globales con conocimiento y experiencia de seguridad digital. Hemos insertado las últimas chips de código de seguridad que utilizan los pasaportes y las tarjetas de crédito para mejorar la seguridad.',
    detail_content3_3:
      'Incluso si pierde clap, puede mantener los activos que posee por el usuario a través del nuevo dispositivo Clap.',
    detail_title_4: 'conveniencia',
    detail_content4_1:
      'Puede ingresar la clave secreta con dos botones ubicados en la parte superior de la llaza.',
    detail_content4_2:
      'Apoyamos más de 40 cifrados, incluidos Bitcoin, Ethereum y XRP, y considerando la conveniencia del usuario.',
    detail_title_6: 'COMO',
    detail_content6_1:
      'A / S para dispositivos de productos es un año a partir de la fecha de compra.',
    detail_content6_2:
      'Si se requiere A / S, visite el Banco de Coco con el cuerpo de la llave.',
    detail_content6_3:
      'Se requiere un número de serie unido a la parte posterior de la lista de A / S. A / S no se puede utilizar para socavar o eliminar el número de serie.',
    detail_content6_4:
      'Puede que A / S puede no ser posible dependiendo del producto del producto causado por su descuido y el estado del producto.',
    detail_title_7: 'darse cuenta',
    detail_content7_1:
      'Los servicios en línea de Clap no están relacionados con ONETETHER porque son atendidos por el libro mayor.',
    detail_content7_2:
      'Si utiliza el producto, tenga en cuenta que el problema de la piratería desde el exterior causado por el problema de piratería externo causado por el descuidado (pérdida, restauración y conectar el código PIN a la PC infectado) no es responsable del Bank COCO.',
    detail_content7_3:
      'Los servicios en línea proporcionados por "Ledger Live" o Ledger son irrelevantes para el dinero que el usuario obtenido por el usuario es irrelevante para el Banco COCO.',
    detail_title_8: 'Compra',
    detail_content8_1: 'Co.u co.u (cafe): 430 1er piso',
    detail_title_9: 'Recepción de A / S',
    detail_content9_1: 'Coco Bank: Seúl, Gangnam-Gu, Seúl 528 2do piso',
    detail_content9_2:
      'No dude en ponerse en contacto con nosotros con el kozuko koh más cercano, o ayudar@cocobank.com.',
  },
}
